import "./App.css";
import Header from "./components/header/header";
import Footer from "./components/footer/footer";
import CalcInputs from "./components/calcInputs/calcInputs";
import React, { Component, Fragment } from "react";
import CreditLengthChange from "./classes/creditLengthChange";
import ConstProc from "./classes/constProc";
import CreditMarginChange from "./classes/creditLengthChange";
import CreditSubsequentsTranchesChange from "./classes/creditSubsequentsTranchesChange";
import CreditEarlyRepaymentChange from "./classes/creditEarlyRepaymentChange";
import JudgmentsList from "./pages/judgments/judgmentsList";
import JudgmentsAdd from "./pages/judgments/judgmentsAdd";
import CompaniesList from "./pages/companies/companiesList";
import CompaniesAdd from "./pages/companies/companiesAdd";
import UsersList from "./pages/users/usersList";
import UsersAdd from "./pages/users/usersAdd";
import swal from "sweetalert";
import Swal2 from "sweetalert2";
import withReactContent from "sweetalert2-react-content";

const MySwal = withReactContent(Swal2);
var usersList = [];

class App extends Component {
  state = {
    clientBank: "",
    expandButtonText: "ROZWIŃ",
    expandPointer: 0,
    expandStyle: 0,
    clientName: "",
    errorName: 0,
    clientPhone: "",
    errorPhone: 0,
    clientMail: "",
    errorMail: 0,
    agreements: [],
    expandStyleAgreement: 0,
    agreementDetailsText: "",
    chooseAgreementPointer: 0,
    clientAgreement: "",
    creditValue: 0,
    errorCreditValue: 0,
    creditCurrency: "CHF",
    creditDate: "",
    creditMargin: 0,
    errorCreditMargin: 0,
    creditLength: 0,
    errorCreditLength: 0,
    creditPaymentType: "równe",
    creditSpread: 3,
    errorCreditSread: 0,
    creditGracePeriod: 0,
    creditLengthChanges: [],
    actualCreditLengthChangeRowDate: "",
    actualCreditLengthChangeRowValue: 0,
    creditMarginChanges: [],
    actualCreditMarginChangeRowDate: "",
    actualCreditMarginChangeRowValue: 0,
    actualCreditSubsequentsTranchesRowDate: "",
    actualCreditSubsequentsTranchesRowValue: 0,
    actualCreditSubsequentsTranchesRowCurrency: "CHF",
    creditSubsequentsTranchesChanges: [],
    actualCreditEarlyRepaymentTranchesRowDate: "",
    actualCreditEarlyRepaymentRowValue: 0,
    actualCreditEarlyRepaymentRowCurrency: "CHF",
    creditEarlyRepaymentChanges: [],
    menuIndicator: "calc",
    errorGracePeriod: 0,
    creditEndDate: "",
    companyId: 1,
    judgmentsList: [],
    banksList: [],
    companiesList: [],
    actualJudgmentDate: "",
    actualJudgmentSignature: "",
    actualJudgmentCourt: "",
    actualJudgmentBank: "",
    actualJudgmentNote: "",
    actualCompanyName: "",
    actualCompanyTemplateID: "",
    actualCompanyFolderID: "",
    actualUserName: "",
    actualUserMail: "",
    actualUserPhone: "",
    actualUserCompanyID: "",
    actualUserType: "",
    actualUserPassword: "",
    userName: "",
    userMail: "",
    userPhone: "",
    userCompanyID: "",
    userCompany: "",
    userType: "user",
    analysisAuthor: "DEMO",
    loggedIn: 0,
    userTemplateID: "",
    userFolderID: "",
    scriptUrl: "",
    scripts: [],
    analysisType: "chf",
    analysisJudgmentsList: "",
    creditTypeText: "kredyt",
    wiborType: "Wibor 3M",
    calcTypes: [],
    constRemainedDebtValue: "",
    errorConstRemainedDebtValue: "",
    additionalFunctions: [],
    constProc: [],
    actualConstProcDateFrom: "",
    actualConstProcDateTo: "",
    actualConstProcValue: "",
    offerType: "default",
    guarantee: true,
    costs: true,
    comission: 0,
    errorComission: "",
    specialTemplates: "",
    specialTemplate: "default",
  };

  fetchAgreements = () => {
    fetch("https://calcapinew.ftpeople.pl/agreements")
      .then((response) => response.json())
      .then((data) => {
        this.setState({
          agreements: data,
        });
      });
  };

  fetchScript = () => {
    fetch(
      "https://calcapinew.ftpeople.pl/scripturl?company=" +
        this.state.userCompanyID
    )
      .then((response) => response.json())
      .then((data) => {
        this.setState({
          scripts: data[0],
          scriptUrl: data[0].chfUrl,
        });
      });
  };

  fetchJudgments = () => {
    fetch(
      "https://calcapinew.ftpeople.pl/judgmentsCompany?companyId=" +
        encodeURI(this.state.userCompanyID)
    )
      .then((response) => response.json())
      .then((data) => {
        this.setState({
          judgmentsList: data.sort(function (a, b) {
            return new Date(b.date) - new Date(a.date);
          }),
        });
      });
  };

  fetchCalcTypes = () => {
    fetch(
      "https://calcapinew.ftpeople.pl/calcTypes?company=" +
        encodeURI(this.state.userCompanyID)
    )
      .then((response) => response.json())
      .then((data) => {
        this.setState({
          calcTypes: data,
        });
      });
  };

  fetchSpecialTemplates = () => {
    fetch(
      "https://calcapinew.ftpeople.pl/specialTemplates?company=" +
        encodeURI(this.state.userCompanyID)
    )
      .then((response) => response.json())
      .then((data) => {
        this.setState({
          specialTemplates: data,
        });
      });
  };

  fetchAdditionalFunctions = () => {
    fetch(
      "https://calcapinew.ftpeople.pl/additionalFunctions?company=" +
        encodeURI(this.state.userCompanyID)
    )
      .then((response) => response.json())
      .then((data) => {
        this.setState({
          additionalFunctions: data,
        });
      });
  };

  fetchBanks = () => {
    fetch("https://calcapinew.ftpeople.pl/banks")
      .then((response) => response.json())
      .then((data) => {
        this.setState({
          banksList: data.filter(
            (el) =>
              el.allowedCompany === "all" ||
              el.allowedCompany === this.props.userCompanyID
          ),
        });
      });
  };

  fetchCompanies = () => {
    fetch("https://calcapinew.ftpeople.pl/companies")
      .then((response) => response.json())
      .then((data) => {
        this.setState({
          companiesList: data,
        });
      });
  };

  fetchAgreementText = (agreement) => {
    fetch(
      'https://calcapinew.ftpeople.pl/agreement_details?agreement="' +
        encodeURI(agreement)
    )
      .then((response) => response.json())
      .then((data) => {
        var pointFinal = "";
        pointFinal = data.map(
          (point) => pointFinal + point.point.replaceAll("_", "\n") + "\n\n"
        );
        var agrText = "";
        pointFinal.map((el) => (agrText = agrText + el));
        agrText =
          this.state.analysisType === "eur"
            ? agrText.replaceAll("CHF", "EUR")
            : this.state.analysisType === "dol"
            ? agrText.replaceAll("CHF", "USD")
            : agrText;
        this.setState({
          agreementDetailsText: this.changeCreditTypeAgreement(
            this.state.creditTypeText,
            agrText
          ),
        });
      });
  };

  fetchDeleteJudgment = (id) => {
    fetch(
      'https://calcapinew.ftpeople.pl/deleteJudgment?judgmentId="' +
        encodeURI(id) +
        '"',
      { method: "post" }
    );
    this.fetchJudgments();
  };

  fetchDeleteCompany = (id) => {
    fetch(
      'https://calcapinew.ftpeople.pl/deleteCompany?companyId="' +
        encodeURI(id) +
        '"',
      { method: "post" }
    );
    this.fetchCompanies();
  };

  fetchInsertJudgment = () => {
    fetch(
      "https://calcapinew.ftpeople.pl/insertJudgment?judgmentDate=" +
        encodeURI(this.state.actualJudgmentDate) +
        "&judgmentSignature=" +
        encodeURI(this.state.actualJudgmentSignature) +
        "&judgmentCourt=" +
        encodeURI(this.state.actualJudgmentCourt) +
        "&judgmentBank=" +
        encodeURI(this.state.actualJudgmentBank) +
        "&judgmentNote=" +
        encodeURI(this.state.actualJudgmentNote) +
        "&companyId=" +
        encodeURI(+this.state.userCompanyID),
      { method: "post" }
    );
    this.fetchJudgments();
  };

  fetchInsertCompany = () => {
    fetch(
      "https://calcapinew.ftpeople.pl/insertCompany?companyName=" +
        encodeURI(this.state.actualCompanyName) +
        "&companyTemplateID=" +
        encodeURI(this.state.actualCompanyTemplateID) +
        "&companyFolderID=" +
        encodeURI(this.state.actualCompanyFolderID),
      { method: "post" }
    );
    this.fetchCompanies();
  };

  fetchUsers = () => {
    fetch("https://calcapinew.ftpeople.pl/users")
      .then((response) => response.json())
      .then((data) => {
        //this.setState({
        //  usersList: data,
        //})
        usersList = data;
      });
  };

  fetchDeleteUser = (id) => {
    fetch(
      'https://calcapinew.ftpeople.pl/deleteUser?userId="' +
        encodeURI(id) +
        '"',
      { method: "post" }
    );
    this.fetchCompanies();
  };

  fetchInsertUser = () => {
    fetch(
      "https://calcapinew.ftpeople.pl/insertUser?userName=" +
        this.state.actualUserName +
        "&userMail=" +
        this.state.actualUserMail +
        "&userPhone=" +
        this.state.actualUserPhone +
        "&userType=" +
        this.state.actualUserType +
        "&userCompanyId=" +
        this.state.actualUserCompanyID +
        "&userPassword=" +
        this.state.actualUserPassword,
      { method: "post" }
    );
    this.fetchUsers();
  };

  showPassInput = () => {
    MySwal.fire({
      title: "Zaloguj się",
      html: `
      <span class="labelSwal">Podaj login:</span><input type="text" name="login" id="login" class="swal2-input" placeholder="login">
      <span class="labelSwal">Podaj hasło:</span><input type="password" name="password" id="password" class="swal2-input" placeholder="hasło">`,
      confirmButtonText: "Zaloguj się",
      allowOutsideClick: false,
      allowEscapeKey: false,
      focusConfirm: false,
      preConfirm: () => {
        const password = Swal2.getPopup().querySelector("#password").value;
        const login = Swal2.getPopup().querySelector("#login").value;
        if (!password || !login) {
          Swal2.showValidationMessage(`Proszę wypełnić dane`);
        }
        return { password: password, login: login };
      },
    }).then((result) => {
      const passwordToCheck = result.value.password;
      const loginToCheck = result.value.login;
      var resultCheck = this.checkPassword(loginToCheck, passwordToCheck);
      if (!resultCheck) {
        MySwal.fire({
          title: "NIEPRAWIDŁOWE HASŁO",
          icon: "error",
        }).then((results) => {
          setTimeout(window.location.reload(false), 0);
        });
      }
    });
  };

  checkPassword = (login, password) => {
    var user = usersList.filter(
      (user) => user.mail === login && user.password === password
    );
    if (user.length > 0) {
      var userCompany = this.state.companiesList.filter(
        (company) => company.id === +user[0].companyId
      );
      var checkType = user[0].companyId === "101" ? "wib" : "chf";
      var checkTemplate =
        user[0].companyId === "101"
          ? userCompany[0].templateWibId.split("/").length > 0
            ? userCompany[0].templateWibId.split("/")[0]
            : userCompany[0].templateWibId
          : userCompany[0].templateChfId.split("/").length > 0
          ? userCompany[0].templateChfId.split("/")[0]
          : userCompany[0].templateChfId;
      var currencyCheck = user[0].companyId === "101" ? "PLN" : "CHF";
      this.setState({
        loggedIn: 1,
        userCompanyID: user[0].companyId,
        userCompany: userCompany[0].name,
        userName: user[0].name,
        userMail: user[0].mail,
        userPhone: user[0].phone,
        userType: user[0].type,
        userTemplateID: checkTemplate,
        userFolderID: userCompany[0].folderID,
        analysisAuthor: userCompany[0].name,
        analysisType: checkType,
        creditCurrency: currencyCheck,
        actualCreditEarlyRepaymentRowCurrency: currencyCheck,
        actualCreditSubsequentsTranchesRowCurrency: currencyCheck,
      });
      this.fetchBanks();
      this.fetchAgreements();
      this.fetchJudgments();
      this.fetchScript();
      this.fetchCalcTypes();
      this.fetchSpecialTemplates();
      this.fetchAdditionalFunctions();
      return true;
    } else {
      return false;
    }
  };

  componentDidMount() {
    this.fetchCompanies();
    this.fetchUsers();
    this.showPassInput();
  }

  expandAdditionalData = (e) => {
    e.preventDefault();

    if (this.state.expandStyle === 0) {
      this.setState({
        expandStyle: 1,
      });
    } else {
      this.setState({
        expandStyle: 0,
      });
    }
  };

  handleShowAgreementPointsDetails = (e) => {
    e.preventDefault();

    if (this.state.expandStyleAgreement === 0) {
      this.setState({
        expandStyleAgreement: 1,
      });
    } else {
      this.setState({
        expandStyleAgreement: 0,
      });
    }
  };

  handleAgreementDetailsTextChange = (e) => {
    e.preventDefault();
    this.setState({
      agreementDetailsText: e.target.value,
    });
  };

  handleOfferTypeChange = (e) => {
    e.preventDefault();
    this.setState({
      offerType: e.target.value,
    });
  };

  handleSpecialTemplateChange = (e) => {
    e.preventDefault();
    this.setState({
      specialTemplate: e.target.value,
    });

    if (e.target.value === "default") {
      this.changeAnalysisType2(this.state.analysisType);
    } else {
      this.setState({
        userTemplateID: this.state.specialTemplates.filter(
          (el) => el.name === e.target.value
        )[0].gid,
      });
    }
  };

  handleClientNameChange = (e) => {
    e.preventDefault();
    if (e.target.value === "") {
      this.setState({
        clientName: e.target.value,
        errorName: 1,
      });
    } else {
      this.setState({
        clientName: e.target.value,
        errorName: 0,
      });
    }
  };

  // TO DO: REGEX FOR POLISH PHONE NUMBERS
  handleClientPhoneChange = (e) => {
    e.preventDefault();

    if (e.target.value === "") {
      this.setState({
        clientPhone: e.target.value,
        errorPhone: 1,
      });
    } else {
      this.setState({
        clientPhone: e.target.value,
        errorPhone: 0,
      });
    }
  };

  // TO DO: REGEX FOR E-MAIL ADDRESS
  handleClientMailChange = (e) => {
    e.preventDefault();

    if (e.target.value === "") {
      this.setState({
        clientMail: e.target.value,
        errorMail: 1,
      });
    } else {
      this.setState({
        clientMail: e.target.value,
        errorMail: 0,
      });
    }
  };

  handleAgreementChange = (e) => {
    e.preventDefault();
    this.fetchAgreementText(e.target.value);
    var bank = e.target.value.split(" | ")[0].split(" - ")[0];
    var judgmentsTable = [];
    var judgmentsForBank = this.state.judgmentsList.filter(
      (el) => el.bank === bank
    );
    var judgmnetsForBankLength = judgmentsForBank.length;
    var judgmentsForView = this.state.judgmentsList
      .filter((el) => el.bank !== bank)
      .slice(0, 20 - judgmnetsForBankLength);
    judgmentsTable = judgmentsForBank.concat(judgmentsForView);
    this.setState({
      chooseAgreementPointer: 1,
      clientAgreement: e.target.value,
      clientBank: bank,
      analysisJudgmentsList: judgmentsTable,
    });
  };

  //TO DO: REGEX FOR VALUE
  handleCreditValueChange = (e) => {
    e.preventDefault();

    var organizedValue = e.target.value.replaceAll(",", ".");

    if (e.target.value === "" || e.target.value === "0") {
      this.setState({
        creditValue: 0,
        errorCreditValue: 1,
      });
    } else {
      this.setState({
        creditValue: +organizedValue,
        errorCreditValue: 0,
      });
    }
  };

  handleGuaranteeChange = (e) => {
    this.setState({
      guarantee: e.target.checked,
    });
  };

  handleCostsChange = (e) => {
    this.setState({
      costs: e.target.checked,
    });
  };

  handleCreditCurrencyChange = (e) => {
    e.preventDefault();
    var template = "";
    if (this.getTemplateId(this.state.analysisType).split("/").length > 1) {
      switch (this.state.analysisType) {
        case "chf": {
          if (e.target.value === "CHF") {
            template =
              this.getTemplateId(this.state.analysisType).split("/").length > 0
                ? this.getTemplateId(this.state.analysisType).split("/")[0]
                : this.getTemplateId(this.state.analysisType);
          } else if (e.target.value === "PLN") {
            template =
              this.getTemplateId(this.state.analysisType).split("/").length > 0
                ? this.getTemplateId(this.state.analysisType).split("/")[1]
                : this.getTemplateId(this.state.analysisType);
          }
          break;
        }
        case "eur": {
          if (e.target.value === "EUR") {
            template =
              this.getTemplateId(this.state.analysisType).split("/").length > 0
                ? this.getTemplateId(this.state.analysisType).split("/")[0]
                : this.getTemplateId(this.state.analysisType);
          } else if (e.target.value === "PLN") {
            template =
              this.getTemplateId(this.state.analysisType).split("/").length > 0
                ? this.getTemplateId(this.state.analysisType).split("/")[1]
                : this.getTemplateId(this.state.analysisType);
          }
          break;
        }
        case "dol": {
          if (e.target.value === "USD") {
            template =
              this.getTemplateId(this.state.analysisType).split("/").length > 0
                ? this.getTemplateId(this.state.analysisType).split("/")[0]
                : this.getTemplateId(this.state.analysisType);
          } else if (e.target.value === "PLN") {
            template =
              this.getTemplateId(this.state.analysisType).split("/").length > 0
                ? this.getTemplateId(this.state.analysisType).split("/")[1]
                : this.getTemplateId(this.state.analysisType);
          }
          break;
        }
        default:
          break;
      }
    } else {
      template = this.getTemplateId(this.state.analysisType);
    }

    if (this.state.specialTemplate === "default") {
      this.setState({
        creditCurrency: e.target.value,
        userTemplateID: template,
      });
    } else {
      this.setState({
        creditCurrency: e.target.value,
      });
    }
  };

  handleCreditDateChange = (e) => {
    e.preventDefault();

    this.setState({
      creditDate: e.target.value,
    });
  };

  handleCreditMarginChange = (e) => {
    e.preventDefault();

    var organizedValue = e.target.value.replaceAll(",", ".");

    if (e.target.value === "" || e.target.value === 0) {
      this.setState({
        creditMargin: 0,
        errorCreditMargin: 1,
      });
    } else {
      this.setState({
        creditMargin: +organizedValue,
        errorCreditMargin: 0,
      });
    }
  };

  //TO DO: REGEX FOR VALUE
  handleCreditLengthChange = (e) => {
    e.preventDefault();

    if (e.target.value === "" || e.target.value === "0") {
      this.setState({
        creditLength: 0,
        errorCreditLength: 1,
      });
    } else {
      this.setState({
        creditLength: e.target.value,
        errorCreditLength: 0,
      });
    }
  };

  handleCreditTypeTextChange = (e) => {
    e.preventDefault();

    this.setState({
      creditTypeText: e.target.value,
      agreementDetailsText: this.changeCreditTypeAgreement(
        e.target.value,
        this.state.agreementDetailsText
      ),
    });
  };

  handleWiborTypeChange = (e) => {
    e.preventDefault();

    this.setState({
      wiborType: e.target.value,
    });
  };

  changeCreditTypeAgreement = (target, toChange) => {
    var agreementText = toChange;

    if (target === "pożyczka") {
      agreementText = agreementText.replaceAll(
        "kredytów hipotecznych",
        "pożyczek"
      );
      agreementText = agreementText.replaceAll(
        "kredytu hipotecznego",
        "pożyczki"
      );
      agreementText = agreementText.replaceAll(
        "Kredytu hipotecznego",
        "Pożyczki"
      );
      agreementText = agreementText.replaceAll("Kredyt hipoteczny", "Pożyczka");
      agreementText = agreementText.replaceAll("wypłacony", "wypłacona");
      agreementText = agreementText.replaceAll("wypłaconego", "wypłaconej");
      agreementText = agreementText.replaceAll(
        "został udzielony",
        "została udzielona"
      );
      agreementText = agreementText.replaceAll("uruchamianego", "uruchamianej");
      agreementText = agreementText.replaceAll("spłaconego", "spłaconej");
      agreementText = agreementText.replaceAll("denominowany", "denominowana");
      agreementText = agreementText.replaceAll(
        "denominowanego",
        "denominowanej"
      );
      agreementText = agreementText.replaceAll(
        "przeznaczonego",
        "przeznaczonej"
      );
      agreementText = agreementText.replaceAll("Kredytem", "Pożyczką");
      agreementText = agreementText.replaceAll("Kredyty", "Pożyczki");
      agreementText = agreementText.replaceAll(
        "Kredytów Hipotecznych",
        "Pożyczek"
      );
      agreementText = agreementText.replaceAll(
        "Kredytów hipotecznych",
        "Pożyczek"
      );
      agreementText = agreementText.replaceAll("Kredytów", "Pożyczek");
      agreementText = agreementText.replaceAll("kredytów", "pożyczek");
      agreementText = agreementText.replaceAll("kredytowania", "pożyczki");
      agreementText = agreementText.replaceAll(
        "Kredytobiorcy",
        "Pożyczkobiorcy"
      );
      agreementText = agreementText.replaceAll("Kredytowania", "Pożyczki dla");
      agreementText = agreementText.replaceAll(
        "Kredytobiorca",
        "Pożyczkobiorca"
      );
      agreementText = agreementText.replaceAll("Kredytu", "Pożyczki");
      agreementText = agreementText.replaceAll("Kredyt", "Pożyczka");
      agreementText = agreementText.replaceAll("Kredytu", "Pożyczki");
      agreementText = agreementText.replaceAll("indeksowany", "indeksowana");
      agreementText = agreementText.replaceAll("indeksowanego", "indeksowanej");
      agreementText = agreementText.replaceAll("uruchomiony", "uruchomiona");
      agreementText = agreementText.replaceAll("uruchamiany", "uruchamiana");
      agreementText = agreementText.replaceAll("kredytu", "pożyczki");
      agreementText = agreementText.replaceAll("kredyt", "pożyczka");
      agreementText = agreementText.replaceAll("udzielonego", "udzielonej");
    } else if (target === "kredyt") {
      agreementText = agreementText.replaceAll(
        "pożyczek",
        "kredytów hipotecznych"
      );
      agreementText = agreementText.replaceAll(
        "pożyczki",
        "kredytu hipotecznego"
      );
      agreementText = agreementText.replaceAll(
        "Pożyczki",
        "Kredytu hipotecznego"
      );
      agreementText = agreementText.replaceAll("Pożyczka", "Kredyt hipoteczny");
      agreementText = agreementText.replaceAll("wypłacony", "wypłacona");
      agreementText = agreementText.replaceAll("wypłaconego", "wypłaconej");
      agreementText = agreementText.replaceAll(
        "została udzielona",
        "został udzielony"
      );
      agreementText = agreementText.replaceAll("uruchamianej", "uruchamianego");
      agreementText = agreementText.replaceAll("spłaconej", "spłaconego");
      agreementText = agreementText.replaceAll("denominowana", "denominowany");
      agreementText = agreementText.replaceAll(
        "denominowanej",
        "denominowanego"
      );
      agreementText = agreementText.replaceAll(
        "przeznaczonej",
        "przeznaczonego"
      );
      agreementText = agreementText.replaceAll("Pożyczką", "Kredytem");
      agreementText = agreementText.replaceAll("Pożyczki", "Kredyty");
      agreementText = agreementText.replaceAll(
        "Pożyczek",
        "Kredytów Hipotecznych"
      );
      agreementText = agreementText.replaceAll(
        "Pożyczek",
        "Kredytów hipotecznych"
      );
      agreementText = agreementText.replaceAll("Pożyczek", "Kredytów");
      agreementText = agreementText.replaceAll("pożyczek", "kredytów");
      agreementText = agreementText.replaceAll("pożyczki", "kredytowania");
      agreementText = agreementText.replaceAll(
        "Pożyczkobiorcy",
        "Kredytobiorcy"
      );
      agreementText = agreementText.replaceAll("Pożyczki dla", "Kredytowania");
      agreementText = agreementText.replaceAll(
        "Pożyczkobiorca",
        "Kredytobiorca"
      );
      agreementText = agreementText.replaceAll("Pożyczki", "Kredytu");
      agreementText = agreementText.replaceAll("Pożyczka", "Kredyt");
      agreementText = agreementText.replaceAll("Pożyczki", "Kredytu");
      agreementText = agreementText.replaceAll("indeksowana", "indeksowany");
      agreementText = agreementText.replaceAll("indeksowanej", "indeksowanego");
      agreementText = agreementText.replaceAll("uruchomiona", "uruchomiony");
      agreementText = agreementText.replaceAll("uruchamiana", "uruchamiany");
      agreementText = agreementText.replaceAll("pożyczki", "kredytu");
      agreementText = agreementText.replaceAll("pożyczka", "kredyt");
      agreementText = agreementText.replaceAll("udzielonej", "udzielonego");
    }

    return agreementText;
  };

  handleCreditPaymentTypeChange = (e) => {
    e.preventDefault();

    this.setState({
      creditPaymentType: e.target.value,
    });
  };

  //TO DO: REGEX FOR VALUE
  handleCreditSpreadChange = (e) => {
    e.preventDefault();

    var organizedValue = e.target.value.replaceAll(",", ".");

    if (e.target.value === "" || e.target.value === "0") {
      this.setState({
        creditSpread: 0,
        errorCreditSpread: 1,
      });
    } else {
      this.setState({
        creditSpread: +organizedValue,
        errorCreditSpread: 0,
      });
    }
  };

  //TO DO: REGEX FOR VALUE
  handleCreditGracePeriodChange = (e) => {
    e.preventDefault();

    if (e.target.value === "") {
      this.setState({
        creditGracePeriod: 0,
      });
    } else {
      this.setState({
        creditGracePeriod: +e.target.value,
      });
    }
  };

  //TO DO: REGEX FOR VALUE
  handleActualCreditLengthChangeRowDateChange = (e) => {
    e.preventDefault();

    this.setState({
      actualCreditLengthChangeRowDate: e.target.value,
    });
  };

  handleActualCreditLengthChangeRowValueChange = (e) => {
    e.preventDefault();

    if (e.target.value === "" || e.target.value === "0") {
      this.setState({
        actualCreditLengthChangeRowValue: 0,
      });
    } else {
      this.setState({
        actualCreditLengthChangeRowValue: +e.target.value,
      });
    }
  };

  handleAddCreditLengthChange = (e) => {
    e.preventDefault();

    if (
      this.state.creditLengthChanges.length === 15 ||
      this.state.actualCreditLengthChangeRowValue === 0 ||
      this.state.actualCreditLengthChangeRowDate === ""
    ) {
      return;
    }

    this.setState((prevState) => ({
      creditLengthChanges: [
        ...prevState.creditLengthChanges,
        new CreditLengthChange(
          prevState.creditLengthChanges.length + 1,
          this.state.actualCreditLengthChangeRowDate,
          this.state.actualCreditLengthChangeRowValue
        ),
      ],
      actualCreditLengthChangeRowDate: "",
      actualCreditLengthChangeRowValue: 0,
    }));
  };

  handleDeleteCreditLengthChange = (e) => {
    e.preventDefault();

    this.setState((prevState) => ({
      creditLengthChanges: prevState.creditLengthChanges.filter(
        (creditLengthChange) => creditLengthChange.key !== +e.target.value
      ),
    }));
  };

  handleAddCreditMarginChange = (e) => {
    e.preventDefault();

    if (
      this.state.creditMarginChanges.length === 15 ||
      this.state.actualCreditMarginChangeRowDate === "" ||
      this.state.actualCreditMarginChangeRowValue === 0
    ) {
      return;
    }

    this.setState((prevState) => ({
      creditMarginChanges: [
        ...prevState.creditMarginChanges,
        new CreditMarginChange(
          prevState.creditMarginChanges.length + 1,
          this.state.actualCreditMarginChangeRowDate,
          this.state.actualCreditMarginChangeRowValue
        ),
      ],
      actualCreditMarginChangeRowDate: "",
      actualCreditMarginChangeRowValue: 0,
    }));
  };

  handleConstProcChange = (e) => {
    e.preventDefault();

    if (
      this.state.constProc.length === 15 ||
      this.state.actualConstProcDateFrom === "" ||
      this.state.actualConstProcDateTo === "" ||
      this.state.actualConstProcValue === 0
    ) {
      return;
    }

    this.setState((prevState) => ({
      constProc: [
        ...prevState.constProc,
        new ConstProc(
          prevState.constProc.length + 1,
          this.state.actualConstProcDateFrom,
          this.state.actualConstProcDateTo,
          this.state.actualConstProcValue
        ),
      ],
      actualConstProcDateFrom: "",
      actualConstProcDateTo: "",
      actualConstProcValue: 0,
    }));
  };

  handleDeleteConstProc = (e) => {
    e.preventDefault();

    this.setState((prevState) => ({
      constProc: prevState.constProc.filter(
        (constProc) => constProc.key !== +e.target.value
      ),
    }));
  };

  handleActualConstProcDateFromChange = (e) => {
    e.preventDefault();

    this.setState({
      actualConstProcDateFrom: e.target.value,
    });
  };

  handleActualConstProcDateToChange = (e) => {
    e.preventDefault();

    this.setState({
      actualConstProcDateTo: e.target.value,
    });
  };

  handleActualConstProcValueChange = (e) => {
    e.preventDefault();

    this.setState({
      actualConstProcValue: e.target.value,
    });
  };

  handleActualCreditMarginChangeRowDateChange = (e) => {
    e.preventDefault();

    this.setState({
      actualCreditMarginChangeRowDate: e.target.value,
    });
  };

  handleActualCreditMarginChangeRowDateChange = (e) => {
    e.preventDefault();

    this.setState({
      actualCreditMarginChangeRowDate: e.target.value,
    });
  };

  handleDeleteCreditMarginChange = (e) => {
    e.preventDefault();

    this.setState((prevState) => ({
      creditMarginChanges: prevState.creditMarginChanges.filter(
        (creditMarginChange) => creditMarginChange.key !== +e.target.value
      ),
    }));
  };

  //TO DO: REGEX FOR VALUE
  handleActualCreditMarginChangeRowDateChange = (e) => {
    e.preventDefault();

    this.setState({
      actualCreditMarginChangeRowDate: e.target.value,
    });
  };

  handleActualCreditMarginChangeRowValueChange = (e) => {
    e.preventDefault();

    if (e.target.value === "" || e.target.value === "0") {
      this.setState({
        actualCreditMarginChangeRowValue: 0,
      });
    } else {
      this.setState({
        actualCreditMarginChangeRowValue: +e.target.value,
      });
    }
  };

  handleAddCreditSubsequentsTranchesChange = (e) => {
    e.preventDefault();

    if (
      this.state.creditSubsequentsTranchesChanges.length === 15 ||
      this.state.actualCreditSubsequentsTranchesRowDate === "" ||
      this.state.actualCreditSubsequentsTranchesRowValue === 0
    ) {
      return;
    }

    var currencyCheck =
      this.state.analysisType === "wib"
        ? "PLN"
        : this.state.analysisType === "chf"
        ? "CHF"
        : this.state.analysisType === "eur"
        ? "EUR"
        : this.state.analysisType === "dol"
        ? "USD"
        : "CHF";
    this.setState((prevState) => ({
      creditSubsequentsTranchesChanges: [
        ...prevState.creditSubsequentsTranchesChanges,
        new CreditSubsequentsTranchesChange(
          prevState.creditSubsequentsTranchesChanges.length + 1,
          this.state.actualCreditSubsequentsTranchesRowDate,
          this.state.actualCreditSubsequentsTranchesRowValue,
          this.state.actualCreditSubsequentsTranchesRowCurrency
        ),
      ],
      actualCreditSubsequentsTranchesRowDate: "",
      actualCreditSubsequentsTranchesRowValue: 0,
      actualCreditSubsequentsTranchesRowCurrency: currencyCheck,
    }));
  };

  handleDeleteCreditSubsequentsTranchesChange = (e) => {
    e.preventDefault();

    this.setState((prevState) => ({
      creditSubsequentsTranchesChanges:
        prevState.creditSubsequentsTranchesChanges.filter(
          (creditSubsequentsTranchesChange) =>
            creditSubsequentsTranchesChange.key !== +e.target.value
        ),
    }));
  };

  //TO DO: REGEX FOR VALUE
  handleActualCreditSubsequentsTranchesRowDateChange = (e) => {
    e.preventDefault();

    this.setState({
      actualCreditSubsequentsTranchesRowDate: e.target.value,
    });
  };

  handleActualCreditSubsequentsTranchesRowValueChange = (e) => {
    e.preventDefault();

    if (e.target.value === "" || e.target.value === "0") {
      this.setState({
        actualCreditSubsequentsTranchesRowValue: 0,
      });
    } else {
      this.setState({
        actualCreditSubsequentsTranchesRowValue: +e.target.value,
      });
    }
  };

  handleActualCreditSubsequentsTranchesRowCurrencyChange = (e) => {
    e.preventDefault();

    this.setState({
      actualCreditSubsequentsTranchesRowCurrency: e.target.value,
    });
  };

  handleAddCreditEarlyRepaymentChange = (e) => {
    e.preventDefault();

    if (
      this.state.creditEarlyRepaymentChanges.length === 15 ||
      this.state.actualCreditEarlyRepaymentRowDate === "" ||
      this.state.actualCreditEarlyRepaymentRowValue === 0
    ) {
      return;
    }

    var currencyCheck =
      this.state.analysisType === "wib"
        ? "PLN"
        : this.state.analysisType === "chf"
        ? "CHF"
        : this.state.analysisType === "eur"
        ? "EUR"
        : this.state.analysisType === "dol"
        ? "USD"
        : "CHF";
    this.setState((prevState) => ({
      creditEarlyRepaymentChanges: [
        ...prevState.creditEarlyRepaymentChanges,
        new CreditEarlyRepaymentChange(
          prevState.creditEarlyRepaymentChanges.length + 1,
          this.state.actualCreditEarlyRepaymentRowDate,
          this.state.actualCreditEarlyRepaymentRowValue,
          this.state.actualCreditEarlyRepaymentRowCurrency
        ),
      ],
      actualCreditEarlyRepaymentRowDate: "",
      actualCreditEarlyRepaymentRowValue: 0,
      actualCreditEarlyRepaymentRowCurrency: currencyCheck,
    }));
  };

  handleDeleteCreditEarlyRepaymentChange = (e) => {
    e.preventDefault();

    this.setState((prevState) => ({
      creditEarlyRepaymentChanges: prevState.creditEarlyRepaymentChanges.filter(
        (creditEarlyRepaymentChange) =>
          creditEarlyRepaymentChange.key !== +e.target.value
      ),
    }));
  };

  handleConstRemainedDebtValue = (e) => {
    e.preventDefault();

    var organizedValue = e.target.value.replaceAll(",", ".");

    if (e.target.value === "" || e.target.value === "0") {
      this.setState({
        constRemainedDebtValue: 0,
        errorConstRemainedDebtValue: 1,
      });
    } else {
      this.setState({
        constRemainedDebtValue: +organizedValue,
        errorConstRemainedDebtValue: 0,
      });
    }
  };

  handleComission = (e) => {
    e.preventDefault();

    var organizedValue = e.target.value.replaceAll(",", ".");

    if (e.target.value === "" || e.target.value === "0") {
      this.setState({
        comission: 0,
        errorComission: 1,
      });
    } else {
      this.setState({
        comission: +organizedValue,
        errorComission: 0,
      });
    }
  };

  //TO DO: REGEX FOR VALUE
  handleActualCreditEarlyRepaymentRowDateChange = (e) => {
    e.preventDefault();

    this.setState({
      actualCreditEarlyRepaymentRowDate: e.target.value,
    });
  };

  handleActualCreditEarlyRepaymentRowValueChange = (e) => {
    e.preventDefault();

    if (e.target.value === "" || e.target.value === "0") {
      this.setState({
        actualCreditEarlyRepaymentRowValue: 0,
      });
    } else {
      this.setState({
        actualCreditEarlyRepaymentRowValue: +e.target.value,
      });
    }
  };

  handleActualCreditEarlyRepaymentRowCurrencyChange = (e) => {
    e.preventDefault();

    this.setState({
      actualCreditEarlyRepaymentRowCurrency: e.target.value,
    });
  };

  handleMenuIndicatorChangeCalc = (e) => {
    this.setState({
      menuIndicator: "calc",
    });
  };

  handleMenuIndicatorChangeJudgmentsList = (e) => {
    this.fetchJudgments();
    this.setState({
      menuIndicator: "judgmentsList",
    });
  };

  handleMenuIndicatorChangeCompaniesList = (e) => {
    this.fetchCompanies();
    this.setState({
      menuIndicator: "companiesList",
    });
  };

  handleMenuIndicatorChangeCompaniesAdd = (e) => {
    this.setState({
      menuIndicator: "companiesAdd",
    });
  };

  handleMenuIndicatorChangeJudgmentsAdd = (e) => {
    this.setState({
      menuIndicator: "judgmentsAdd",
    });
  };

  handleMenuIndicatorChangeUsersList = (e) => {
    this.fetchUsers();
    this.setState({
      menuIndicator: "usersList",
    });
  };

  handleMenuIndicatorChangeUsersAdd = (e) => {
    this.setState({
      menuIndicator: "usersAdd",
    });
  };

  doAnalysis = (e) => {
    e.preventDefault();
    this.setNewCalculate();
  };

  setNewCalculate() {
    if (!this.validateForm()) {
      swal("Błąd!", "Uzupełnij wymagane pola formularza.", "error", {
        dangerMode: true,
        closeOnEsc: false,
        closeOnClickOutside: false,
      });
      return;
    }

    var options, url;

    var currency = "";
    switch (this.state.analysisType) {
      case "chf":
        currency = "CHF";
        break;
      case "usd":
        currency = "USD";
        break;
      case "eur":
        currency = "EUR";
        break;
      case "wib":
        currency = "PLN";
        break;
      default:
        currency = "CHF";
    }

    var payload = {
      analysisType: this.state.analysisType,
      clientBank: this.state.clientAgreement,
      clientName: this.state.clientName,
      clientPhone: this.state.clientPhone,
      clientMail: this.state.clientMail,
      clientCreditValueCHF:
        this.state.creditCurrency === currency ? this.state.creditValue : "",
      clientCreditValuePLN:
        this.state.creditCurrency === "PLN" ? this.state.creditValue : "",
      clientCreditStartDate: this.state.creditDate,
      clientCreditMargin: this.state.creditMargin / 100,
      clientCreditLength: this.state.creditLength,
      clientCreditDelayLength: this.state.creditGracePeriod,
      clientCreditSpreadValue: this.state.creditSpread / 100,
      comission: this.state.comission,

      clientCreditLengthChangeDate1:
        this.state.creditLengthChanges.length > 0
          ? this.state.creditLengthChanges[0].date
          : "",
      clientCreditLengthChangeDate2:
        this.state.creditLengthChanges.length > 1
          ? this.state.creditLengthChanges[1].date
          : "",
      clientCreditLengthChangeDate3:
        this.state.creditLengthChanges.length > 2
          ? this.state.creditLengthChanges[2].date
          : "",
      clientCreditLengthChangeDate4:
        this.state.creditLengthChanges.length > 3
          ? this.state.creditLengthChanges[3].date
          : "",
      clientCreditLengthChangeDate5:
        this.state.creditLengthChanges.length > 4
          ? this.state.creditLengthChanges[4].date
          : "",
      clientCreditLengthChangeDate6:
        this.state.creditLengthChanges.length > 5
          ? this.state.creditLengthChanges[5].date
          : "",
      clientCreditLengthChangeDate7:
        this.state.creditLengthChanges.length > 6
          ? this.state.creditLengthChanges[6].date
          : "",
      clientCreditLengthChangeDate8:
        this.state.creditLengthChanges.length > 7
          ? this.state.creditLengthChanges[7].date
          : "",
      clientCreditLengthChangeDate9:
        this.state.creditLengthChanges.length > 8
          ? this.state.creditLengthChanges[8].date
          : "",
      clientCreditLengthChangeDate10:
        this.state.creditLengthChanges.length > 9
          ? this.state.creditLengthChanges[9].date
          : "",
      clientCreditLengthChangeDate11:
        this.state.creditLengthChanges.length > 10
          ? this.state.creditLengthChanges[10].date
          : "",
      clientCreditLengthChangeDate12:
        this.state.creditLengthChanges.length > 11
          ? this.state.creditLengthChanges[11].date
          : "",
      clientCreditLengthChangeDate13:
        this.state.creditLengthChanges.length > 12
          ? this.state.creditLengthChanges[12].date
          : "",
      clientCreditLengthChangeDate14:
        this.state.creditLengthChanges.length > 13
          ? this.state.creditLengthChanges[13].date
          : "",
      clientCreditLengthChangeDate15:
        this.state.creditLengthChanges.length > 14
          ? this.state.creditLengthChanges[14].date
          : "",

      clientCreditLengthChangeValue1:
        this.state.creditLengthChanges.length > 0
          ? this.state.creditLengthChanges[0].value
          : "",
      clientCreditLengthChangeValue2:
        this.state.creditLengthChanges.length > 1
          ? this.state.creditLengthChanges[1].value
          : "",
      clientCreditLengthChangeValue3:
        this.state.creditLengthChanges.length > 2
          ? this.state.creditLengthChanges[2].value
          : "",
      clientCreditLengthChangeValue4:
        this.state.creditLengthChanges.length > 3
          ? this.state.creditLengthChanges[3].value
          : "",
      clientCreditLengthChangeValue5:
        this.state.creditLengthChanges.length > 4
          ? this.state.creditLengthChanges[4].value
          : "",
      clientCreditLengthChangeValue6:
        this.state.creditLengthChanges.length > 5
          ? this.state.creditLengthChanges[5].value
          : "",
      clientCreditLengthChangeValue7:
        this.state.creditLengthChanges.length > 6
          ? this.state.creditLengthChanges[6].value
          : "",
      clientCreditLengthChangeValue8:
        this.state.creditLengthChanges.length > 7
          ? this.state.creditLengthChanges[7].value
          : "",
      clientCreditLengthChangeValue9:
        this.state.creditLengthChanges.length > 8
          ? this.state.creditLengthChanges[8].value
          : "",
      clientCreditLengthChangeValue10:
        this.state.creditLengthChanges.length > 9
          ? this.state.creditLengthChanges[9].value
          : "",
      clientCreditLengthChangeValue11:
        this.state.creditLengthChanges.length > 10
          ? this.state.creditLengthChanges[10].value
          : "",
      clientCreditLengthChangeValue12:
        this.state.creditLengthChanges.length > 11
          ? this.state.creditLengthChanges[11].value
          : "",
      clientCreditLengthChangeValue13:
        this.state.creditLengthChanges.length > 12
          ? this.state.creditLengthChanges[12].value
          : "",
      clientCreditLengthChangeValue14:
        this.state.creditLengthChanges.length > 13
          ? this.state.creditLengthChanges[13].value
          : "",
      clientCreditLengthChangeValue15:
        this.state.creditLengthChanges.length > 14
          ? this.state.creditLengthChanges[14].value
          : "",

      clientCreditMarginChangeDate1:
        this.state.creditMarginChanges.length > 0
          ? this.state.creditMarginChanges[0].date
          : "",
      clientCreditMarginChangeDate2:
        this.state.creditMarginChanges.length > 1
          ? this.state.creditMarginChanges[1].date
          : "",
      clientCreditMarginChangeDate3:
        this.state.creditMarginChanges.length > 2
          ? this.state.creditMarginChanges[2].date
          : "",
      clientCreditMarginChangeDate4:
        this.state.creditMarginChanges.length > 3
          ? this.state.creditMarginChanges[3].date
          : "",
      clientCreditMarginChangeDate5:
        this.state.creditMarginChanges.length > 4
          ? this.state.creditMarginChanges[4].date
          : "",
      clientCreditMarginChangeDate6:
        this.state.creditMarginChanges.length > 5
          ? this.state.creditMarginChanges[5].date
          : "",
      clientCreditMarginChangeValue1:
        this.state.creditMarginChanges.length > 0
          ? this.state.creditMarginChanges[0].value / 100
          : "",
      clientCreditMarginChangeValue2:
        this.state.creditMarginChanges.length > 1
          ? this.state.creditMarginChanges[1].value / 100
          : "",
      clientCreditMarginChangeValue3:
        this.state.creditMarginChanges.length > 2
          ? this.state.creditMarginChanges[2].value / 100
          : "",
      clientCreditMarginChangeValue4:
        this.state.creditMarginChanges.length > 3
          ? this.state.creditMarginChanges[3].value / 100
          : "",
      clientCreditMarginChangeValue5:
        this.state.creditMarginChanges.length > 4
          ? this.state.creditMarginChanges[4].value / 100
          : "",
      clientCreditMarginChangeValue6:
        this.state.creditMarginChanges.length > 5
          ? this.state.creditMarginChanges[5].value / 100
          : "",
      clientCreditMarginChangeValue7:
        this.state.creditMarginChanges.length > 6
          ? this.state.creditMarginChanges[6].value / 100
          : "",
      clientCreditMarginChangeValue8:
        this.state.creditMarginChanges.length > 7
          ? this.state.creditMarginChanges[7].value / 100
          : "",
      clientCreditMarginChangeValue9:
        this.state.creditMarginChanges.length > 8
          ? this.state.creditMarginChanges[8].value / 100
          : "",
      clientCreditMarginChangeValue10:
        this.state.creditMarginChanges.length > 9
          ? this.state.creditMarginChanges[9].value / 100
          : "",
      clientCreditMarginChangeValue11:
        this.state.creditMarginChanges.length > 10
          ? this.state.creditMarginChanges[10].value / 100
          : "",
      clientCreditMarginChangeValue12:
        this.state.creditMarginChanges.length > 11
          ? this.state.creditMarginChanges[11].value / 100
          : "",
      clientCreditMarginChangeValue13:
        this.state.creditMarginChanges.length > 12
          ? this.state.creditMarginChanges[12].value / 100
          : "",
      clientCreditMarginChangeValue14:
        this.state.creditMarginChanges.length > 13
          ? this.state.creditMarginChanges[13].value / 100
          : "",
      clientCreditMarginChangeValue15:
        this.state.creditMarginChanges.length > 14
          ? this.state.creditMarginChanges[14].value / 100
          : "",

      clientCreditSubsequentsTranchesDate1:
        this.state.creditSubsequentsTranchesChanges.length > 0
          ? this.state.creditSubsequentsTranchesChanges[0].date
          : "",
      clientCreditSubsequentsTranchesDate2:
        this.state.creditSubsequentsTranchesChanges.length > 1
          ? this.state.creditSubsequentsTranchesChanges[1].date
          : "",
      clientCreditSubsequentsTranchesDate3:
        this.state.creditSubsequentsTranchesChanges.length > 2
          ? this.state.creditSubsequentsTranchesChanges[2].date
          : "",
      clientCreditSubsequentsTranchesDate4:
        this.state.creditSubsequentsTranchesChanges.length > 3
          ? this.state.creditSubsequentsTranchesChanges[3].date
          : "",
      clientCreditSubsequentsTranchesDate5:
        this.state.creditSubsequentsTranchesChanges.length > 4
          ? this.state.creditSubsequentsTranchesChanges[4].date
          : "",
      clientCreditSubsequentsTranchesDate6:
        this.state.creditSubsequentsTranchesChanges.length > 5
          ? this.state.creditSubsequentsTranchesChanges[5].date
          : "",
      clientCreditSubsequentsTranchesDate7:
        this.state.creditSubsequentsTranchesChanges.length > 6
          ? this.state.creditSubsequentsTranchesChanges[6].date
          : "",
      clientCreditSubsequentsTranchesDate8:
        this.state.creditSubsequentsTranchesChanges.length > 7
          ? this.state.creditSubsequentsTranchesChanges[7].date
          : "",
      clientCreditSubsequentsTranchesDate9:
        this.state.creditSubsequentsTranchesChanges.length > 8
          ? this.state.creditSubsequentsTranchesChanges[8].date
          : "",
      clientCreditSubsequentsTranchesDate10:
        this.state.creditSubsequentsTranchesChanges.length > 9
          ? this.state.creditSubsequentsTranchesChanges[9].date
          : "",
      clientCreditSubsequentsTranchesDate11:
        this.state.creditSubsequentsTranchesChanges.length > 10
          ? this.state.creditSubsequentsTranchesChanges[10].date
          : "",
      clientCreditSubsequentsTranchesDate12:
        this.state.creditSubsequentsTranchesChanges.length > 11
          ? this.state.creditSubsequentsTranchesChanges[11].date
          : "",
      clientCreditSubsequentsTranchesDate13:
        this.state.creditSubsequentsTranchesChanges.length > 12
          ? this.state.creditSubsequentsTranchesChanges[12].date
          : "",
      clientCreditSubsequentsTranchesDate14:
        this.state.creditSubsequentsTranchesChanges.length > 13
          ? this.state.creditSubsequentsTranchesChanges[13].date
          : "",
      clientCreditSubsequentsTranchesDate15:
        this.state.creditSubsequentsTranchesChanges.length > 14
          ? this.state.creditSubsequentsTranchesChanges[14].date
          : "",

      clientCreditSubsequentsTranchesValuePLN1:
        this.state.creditSubsequentsTranchesChanges.length > 0 &&
        this.state.creditSubsequentsTranchesChanges[0].currency === "PLN"
          ? this.state.creditSubsequentsTranchesChanges[0].value
          : "",
      clientCreditSubsequentsTranchesValuePLN2:
        this.state.creditSubsequentsTranchesChanges.length > 1 &&
        this.state.creditSubsequentsTranchesChanges[1].currency === "PLN"
          ? this.state.creditSubsequentsTranchesChanges[1].value
          : "",
      clientCreditSubsequentsTranchesValuePLN3:
        this.state.creditSubsequentsTranchesChanges.length > 2 &&
        this.state.creditSubsequentsTranchesChanges[2].currency === "PLN"
          ? this.state.creditSubsequentsTranchesChanges[2].value
          : "",
      clientCreditSubsequentsTranchesValuePLN4:
        this.state.creditSubsequentsTranchesChanges.length > 3 &&
        this.state.creditSubsequentsTranchesChanges[3].currency === "PLN"
          ? this.state.creditSubsequentsTranchesChanges[3].value
          : "",
      clientCreditSubsequentsTranchesValuePLN5:
        this.state.creditSubsequentsTranchesChanges.length > 4 &&
        this.state.creditSubsequentsTranchesChanges[4].currency === "PLN"
          ? this.state.creditSubsequentsTranchesChanges[4].value
          : "",
      clientCreditSubsequentsTranchesValuePLN6:
        this.state.creditSubsequentsTranchesChanges.length > 5 &&
        this.state.creditSubsequentsTranchesChanges[5].currency === "PLN"
          ? this.state.creditSubsequentsTranchesChanges[5].value
          : "",
      clientCreditSubsequentsTranchesValuePLN7:
        this.state.creditSubsequentsTranchesChanges.length > 6 &&
        this.state.creditSubsequentsTranchesChanges[6].currency === "PLN"
          ? this.state.creditSubsequentsTranchesChanges[6].value
          : "",
      clientCreditSubsequentsTranchesValuePLN8:
        this.state.creditSubsequentsTranchesChanges.length > 7 &&
        this.state.creditSubsequentsTranchesChanges[7].currency === "PLN"
          ? this.state.creditSubsequentsTranchesChanges[7].value
          : "",
      clientCreditSubsequentsTranchesValuePLN9:
        this.state.creditSubsequentsTranchesChanges.length > 8 &&
        this.state.creditSubsequentsTranchesChanges[8].currency === "PLN"
          ? this.state.creditSubsequentsTranchesChanges[8].value
          : "",
      clientCreditSubsequentsTranchesValuePLN10:
        this.state.creditSubsequentsTranchesChanges.length > 9 &&
        this.state.creditSubsequentsTranchesChanges[9].currency === "PLN"
          ? this.state.creditSubsequentsTranchesChanges[9].value
          : "",
      clientCreditSubsequentsTranchesValuePLN11:
        this.state.creditSubsequentsTranchesChanges.length > 10 &&
        this.state.creditSubsequentsTranchesChanges[10].currency === "PLN"
          ? this.state.creditSubsequentsTranchesChanges[10].value
          : "",
      clientCreditSubsequentsTranchesValuePLN12:
        this.state.creditSubsequentsTranchesChanges.length > 11 &&
        this.state.creditSubsequentsTranchesChanges[11].currency === "PLN"
          ? this.state.creditSubsequentsTranchesChanges[11].value
          : "",
      clientCreditSubsequentsTranchesValuePLN13:
        this.state.creditSubsequentsTranchesChanges.length > 12 &&
        this.state.creditSubsequentsTranchesChanges[12].currency === "PLN"
          ? this.state.creditSubsequentsTranchesChanges[12].value
          : "",
      clientCreditSubsequentsTranchesValuePLN14:
        this.state.creditSubsequentsTranchesChanges.length > 13 &&
        this.state.creditSubsequentsTranchesChanges[13].currency === "PLN"
          ? this.state.creditSubsequentsTranchesChanges[13].value
          : "",
      clientCreditSubsequentsTranchesValuePLN15:
        this.state.creditSubsequentsTranchesChanges.length > 14 &&
        this.state.creditSubsequentsTranchesChanges[14].currency === "PLN"
          ? this.state.creditSubsequentsTranchesChanges[14].value
          : "",

      clientCreditSubsequentsTranchesValueCHF1:
        this.state.creditSubsequentsTranchesChanges.length > 0 &&
        this.state.creditSubsequentsTranchesChanges[0].currency === currency
          ? this.state.creditSubsequentsTranchesChanges[0].value
          : "",
      clientCreditSubsequentsTranchesValueCHF2:
        this.state.creditSubsequentsTranchesChanges.length > 1 &&
        this.state.creditSubsequentsTranchesChanges[1].currency === currency
          ? this.state.creditSubsequentsTranchesChanges[1].value
          : "",
      clientCreditSubsequentsTranchesValueCHF3:
        this.state.creditSubsequentsTranchesChanges.length > 2 &&
        this.state.creditSubsequentsTranchesChanges[2].currency === currency
          ? this.state.creditSubsequentsTranchesChanges[2].value
          : "",
      clientCreditSubsequentsTranchesValueCHF4:
        this.state.creditSubsequentsTranchesChanges.length > 3 &&
        this.state.creditSubsequentsTranchesChanges[3].currency === currency
          ? this.state.creditSubsequentsTranchesChanges[3].value
          : "",
      clientCreditSubsequentsTranchesValueCHF5:
        this.state.creditSubsequentsTranchesChanges.length > 4 &&
        this.state.creditSubsequentsTranchesChanges[4].currency === currency
          ? this.state.creditSubsequentsTranchesChanges[4].value
          : "",
      clientCreditSubsequentsTranchesValueCHF6:
        this.state.creditSubsequentsTranchesChanges.length > 5 &&
        this.state.creditSubsequentsTranchesChanges[5].currency === currency
          ? this.state.creditSubsequentsTranchesChanges[5].value
          : "",
      clientCreditSubsequentsTranchesValueCHF7:
        this.state.creditSubsequentsTranchesChanges.length > 6 &&
        this.state.creditSubsequentsTranchesChanges[6].currency === currency
          ? this.state.creditSubsequentsTranchesChanges[6].value
          : "",
      clientCreditSubsequentsTranchesValueCHF8:
        this.state.creditSubsequentsTranchesChanges.length > 7 &&
        this.state.creditSubsequentsTranchesChanges[7].currency === currency
          ? this.state.creditSubsequentsTranchesChanges[7].value
          : "",
      clientCreditSubsequentsTranchesValueCHF9:
        this.state.creditSubsequentsTranchesChanges.length > 8 &&
        this.state.creditSubsequentsTranchesChanges[8].currency === currency
          ? this.state.creditSubsequentsTranchesChanges[8].value
          : "",
      clientCreditSubsequentsTranchesValueCHF10:
        this.state.creditSubsequentsTranchesChanges.length > 9 &&
        this.state.creditSubsequentsTranchesChanges[9].currency === currency
          ? this.state.creditSubsequentsTranchesChanges[9].value
          : "",
      clientCreditSubsequentsTranchesValueCHF11:
        this.state.creditSubsequentsTranchesChanges.length > 10 &&
        this.state.creditSubsequentsTranchesChanges[10].currency === currency
          ? this.state.creditSubsequentsTranchesChanges[10].value
          : "",
      clientCreditSubsequentsTranchesValueCHF12:
        this.state.creditSubsequentsTranchesChanges.length > 11 &&
        this.state.creditSubsequentsTranchesChanges[11].currency === currency
          ? this.state.creditSubsequentsTranchesChanges[11].value
          : "",
      clientCreditSubsequentsTranchesValueCHF13:
        this.state.creditSubsequentsTranchesChanges.length > 12 &&
        this.state.creditSubsequentsTranchesChanges[12].currency === currency
          ? this.state.creditSubsequentsTranchesChanges[12].value
          : "",
      clientCreditSubsequentsTranchesValueCHF14:
        this.state.creditSubsequentsTranchesChanges.length > 13 &&
        this.state.creditSubsequentsTranchesChanges[13].currency === currency
          ? this.state.creditSubsequentsTranchesChanges[13].value
          : "",
      clientCreditSubsequentsTranchesValueCHF15:
        this.state.creditSubsequentsTranchesChanges.length > 14 &&
        this.state.creditSubsequentsTranchesChanges[14].currency === currency
          ? this.state.creditSubsequentsTranchesChanges[14].value
          : "",

      clientCreditEarlyRepaymentDate1:
        this.state.creditEarlyRepaymentChanges.length > 0
          ? this.state.creditEarlyRepaymentChanges[0].date
          : "",
      clientCreditEarlyRepaymentDate2:
        this.state.creditEarlyRepaymentChanges.length > 1
          ? this.state.creditEarlyRepaymentChanges[1].date
          : "",
      clientCreditEarlyRepaymentDate3:
        this.state.creditEarlyRepaymentChanges.length > 2
          ? this.state.creditEarlyRepaymentChanges[2].date
          : "",
      clientCreditEarlyRepaymentDate4:
        this.state.creditEarlyRepaymentChanges.length > 3
          ? this.state.creditEarlyRepaymentChanges[3].date
          : "",
      clientCreditEarlyRepaymentDate5:
        this.state.creditEarlyRepaymentChanges.length > 4
          ? this.state.creditEarlyRepaymentChanges[4].date
          : "",
      clientCreditEarlyRepaymentDate6:
        this.state.creditEarlyRepaymentChanges.length > 5
          ? this.state.creditEarlyRepaymentChanges[5].date
          : "",
      clientCreditEarlyRepaymentDate7:
        this.state.creditEarlyRepaymentChanges.length > 6
          ? this.state.creditEarlyRepaymentChanges[6].date
          : "",
      clientCreditEarlyRepaymentDate8:
        this.state.creditEarlyRepaymentChanges.length > 7
          ? this.state.creditEarlyRepaymentChanges[7].date
          : "",
      clientCreditEarlyRepaymentDate9:
        this.state.creditEarlyRepaymentChanges.length > 8
          ? this.state.creditEarlyRepaymentChanges[8].date
          : "",
      clientCreditEarlyRepaymentDate10:
        this.state.creditEarlyRepaymentChanges.length > 9
          ? this.state.creditEarlyRepaymentChanges[9].date
          : "",
      clientCreditEarlyRepaymentDate11:
        this.state.creditEarlyRepaymentChanges.length > 10
          ? this.state.creditEarlyRepaymentChanges[10].date
          : "",
      clientCreditEarlyRepaymentDate12:
        this.state.creditEarlyRepaymentChanges.length > 11
          ? this.state.creditEarlyRepaymentChanges[11].date
          : "",
      clientCreditEarlyRepaymentDate13:
        this.state.creditEarlyRepaymentChanges.length > 12
          ? this.state.creditEarlyRepaymentChanges[12].date
          : "",
      clientCreditEarlyRepaymentDate14:
        this.state.creditEarlyRepaymentChanges.length > 13
          ? this.state.creditEarlyRepaymentChanges[13].date
          : "",
      clientCreditEarlyRepaymentDate15:
        this.state.creditEarlyRepaymentChanges.length > 14
          ? this.state.creditEarlyRepaymentChanges[14].date
          : "",

      clientCreditEarlyRepaymentValuePLN1:
        this.state.creditEarlyRepaymentChanges.length > 0 &&
        this.state.creditEarlyRepaymentChanges[0].currency === "PLN"
          ? this.state.creditEarlyRepaymentChanges[0].value
          : "",
      clientCreditEarlyRepaymentValuePLN2:
        this.state.creditEarlyRepaymentChanges.length > 1 &&
        this.state.creditEarlyRepaymentChanges[1].currency === "PLN"
          ? this.state.creditEarlyRepaymentChanges[1].value
          : "",
      clientCreditEarlyRepaymentValuePLN3:
        this.state.creditEarlyRepaymentChanges.length > 2 &&
        this.state.creditEarlyRepaymentChanges[2].currency === "PLN"
          ? this.state.creditEarlyRepaymentChanges[2].value
          : "",
      clientCreditEarlyRepaymentValuePLN4:
        this.state.creditEarlyRepaymentChanges.length > 3 &&
        this.state.creditEarlyRepaymentChanges[3].currency === "PLN"
          ? this.state.creditEarlyRepaymentChanges[3].value
          : "",
      clientCreditEarlyRepaymentValuePLN5:
        this.state.creditEarlyRepaymentChanges.length > 4 &&
        this.state.creditEarlyRepaymentChanges[4].currency === "PLN"
          ? this.state.creditEarlyRepaymentChanges[4].value
          : "",
      clientCreditEarlyRepaymentValuePLN6:
        this.state.creditEarlyRepaymentChanges.length > 5 &&
        this.state.creditEarlyRepaymentChanges[5].currency === "PLN"
          ? this.state.creditEarlyRepaymentChanges[5].value
          : "",
      clientCreditEarlyRepaymentValuePLN7:
        this.state.creditEarlyRepaymentChanges.length > 6 &&
        this.state.creditEarlyRepaymentChanges[6].currency === "PLN"
          ? this.state.creditEarlyRepaymentChanges[6].value
          : "",
      clientCreditEarlyRepaymentValuePLN8:
        this.state.creditEarlyRepaymentChanges.length > 7 &&
        this.state.creditEarlyRepaymentChanges[7].currency === "PLN"
          ? this.state.creditEarlyRepaymentChanges[7].value
          : "",
      clientCreditEarlyRepaymentValuePLN9:
        this.state.creditEarlyRepaymentChanges.length > 8 &&
        this.state.creditEarlyRepaymentChanges[8].currency === "PLN"
          ? this.state.creditEarlyRepaymentChanges[8].value
          : "",
      clientCreditEarlyRepaymentValuePLN10:
        this.state.creditEarlyRepaymentChanges.length > 9 &&
        this.state.creditEarlyRepaymentChanges[9].currency === "PLN"
          ? this.state.creditEarlyRepaymentChanges[9].value
          : "",
      clientCreditEarlyRepaymentValuePLN11:
        this.state.creditEarlyRepaymentChanges.length > 10 &&
        this.state.creditEarlyRepaymentChanges[10].currency === "PLN"
          ? this.state.creditEarlyRepaymentChanges[10].value
          : "",
      clientCreditEarlyRepaymentValuePLN12:
        this.state.creditEarlyRepaymentChanges.length > 11 &&
        this.state.creditEarlyRepaymentChanges[11].currency === "PLN"
          ? this.state.creditEarlyRepaymentChanges[11].value
          : "",
      clientCreditEarlyRepaymentValuePLN13:
        this.state.creditEarlyRepaymentChanges.length > 12 &&
        this.state.creditEarlyRepaymentChanges[12].currency === "PLN"
          ? this.state.creditEarlyRepaymentChanges[12].value
          : "",
      clientCreditEarlyRepaymentValuePLN14:
        this.state.creditEarlyRepaymentChanges.length > 13 &&
        this.state.creditEarlyRepaymentChanges[13].currency === "PLN"
          ? this.state.creditEarlyRepaymentChanges[13].value
          : "",
      clientCreditEarlyRepaymentValuePLN15:
        this.state.creditEarlyRepaymentChanges.length > 14 &&
        this.state.creditEarlyRepaymentChanges[14].currency === "PLN"
          ? this.state.creditEarlyRepaymentChanges[14].value
          : "",

      clientCreditEarlyRepaymentValueCHF1:
        this.state.creditEarlyRepaymentChanges.length > 0 &&
        this.state.creditEarlyRepaymentChanges[0].currency === currency
          ? this.state.creditEarlyRepaymentChanges[0].value
          : "",
      clientCreditEarlyRepaymentValueCHF2:
        this.state.creditEarlyRepaymentChanges.length > 1 &&
        this.state.creditEarlyRepaymentChanges[1].currency === currency
          ? this.state.creditEarlyRepaymentChanges[1].value
          : "",
      clientCreditEarlyRepaymentValueCHF3:
        this.state.creditEarlyRepaymentChanges.length > 2 &&
        this.state.creditEarlyRepaymentChanges[2].currency === currency
          ? this.state.creditEarlyRepaymentChanges[2].value
          : "",
      clientCreditEarlyRepaymentValueCHF4:
        this.state.creditEarlyRepaymentChanges.length > 3 &&
        this.state.creditEarlyRepaymentChanges[3].currency === currency
          ? this.state.creditEarlyRepaymentChanges[3].value
          : "",
      clientCreditEarlyRepaymentValueCHF5:
        this.state.creditEarlyRepaymentChanges.length > 4 &&
        this.state.creditEarlyRepaymentChanges[4].currency === currency
          ? this.state.creditEarlyRepaymentChanges[4].value
          : "",
      clientCreditEarlyRepaymentValueCHF6:
        this.state.creditEarlyRepaymentChanges.length > 5 &&
        this.state.creditEarlyRepaymentChanges[5].currency === currency
          ? this.state.creditEarlyRepaymentChanges[5].value
          : "",
      clientCreditEarlyRepaymentValueCHF7:
        this.state.creditEarlyRepaymentChanges.length > 6 &&
        this.state.creditEarlyRepaymentChanges[6].currency === currency
          ? this.state.creditEarlyRepaymentChanges[6].value
          : "",
      clientCreditEarlyRepaymentValueCHF8:
        this.state.creditEarlyRepaymentChanges.length > 7 &&
        this.state.creditEarlyRepaymentChanges[7].currency === currency
          ? this.state.creditEarlyRepaymentChanges[7].value
          : "",
      clientCreditEarlyRepaymentValueCHF9:
        this.state.creditEarlyRepaymentChanges.length > 8 &&
        this.state.creditEarlyRepaymentChanges[8].currency === currency
          ? this.state.creditEarlyRepaymentChanges[8].value
          : "",
      clientCreditEarlyRepaymentValueCHF10:
        this.state.creditEarlyRepaymentChanges.length > 9 &&
        this.state.creditEarlyRepaymentChanges[9].currency === currency
          ? this.state.creditEarlyRepaymentChanges[9].value
          : "",
      clientCreditEarlyRepaymentValueCHF11:
        this.state.creditEarlyRepaymentChanges.length > 10 &&
        this.state.creditEarlyRepaymentChanges[10].currency === currency
          ? this.state.creditEarlyRepaymentChanges[10].value
          : "",
      clientCreditEarlyRepaymentValueCHF12:
        this.state.creditEarlyRepaymentChanges.length > 11 &&
        this.state.creditEarlyRepaymentChanges[11].currency === currency
          ? this.state.creditEarlyRepaymentChanges[11].value
          : "",
      clientCreditEarlyRepaymentValueCHF13:
        this.state.creditEarlyRepaymentChanges.length > 12 &&
        this.state.creditEarlyRepaymentChanges[12].currency === currency
          ? this.state.creditEarlyRepaymentChanges[12].value
          : "",
      clientCreditEarlyRepaymentValueCHF14:
        this.state.creditEarlyRepaymentChanges.length > 13 &&
        this.state.creditEarlyRepaymentChanges[13].currency === currency
          ? this.state.creditEarlyRepaymentChanges[13].value
          : "",
      clientCreditEarlyRepaymentValueCHF15:
        this.state.creditEarlyRepaymentChanges.length > 14 &&
        this.state.creditEarlyRepaymentChanges[14].currency === currency
          ? this.state.creditEarlyRepaymentChanges[14].value
          : "",

      clientConstProcDateFrom1:
        this.state.constProc.length > 0 ? this.state.constProc[0].dateFrom : "",
      clientConstProcDateFrom2:
        this.state.constProc.length > 1 ? this.state.constProc[1].dateFrom : "",
      clientConstProcDateFrom3:
        this.state.constProc.length > 2 ? this.state.constProc[2].dateFrom : "",
      clientConstProcDateFrom4:
        this.state.constProc.length > 3 ? this.state.constProc[3].dateFrom : "",
      clientConstProcDateFrom5:
        this.state.constProc.length > 4 ? this.state.constProc[4].dateFrom : "",
      clientConstProcDateFrom6:
        this.state.constProc.length > 5 ? this.state.constProc[5].dateFrom : "",
      clientConstProcDateFrom7:
        this.state.constProc.length > 6 ? this.state.constProc[6].dateFrom : "",
      clientConstProcDateFrom8:
        this.state.constProc.length > 7 ? this.state.constProc[7].dateFrom : "",
      clientConstProcDateFrom9:
        this.state.constProc.length > 8 ? this.state.constProc[8].dateFrom : "",
      clientConstProcDateFrom10:
        this.state.constProc.length > 9 ? this.state.constProc[9].dateFrom : "",
      clientConstProcDateFrom11:
        this.state.constProc.length > 10
          ? this.state.constProc[10].dateFrom
          : "",
      clientConstProcDateFrom12:
        this.state.constProc.length > 11
          ? this.state.constProc[11].dateFrom
          : "",
      clientConstProcDateFrom13:
        this.state.constProc.length > 12
          ? this.state.constProc[12].dateFrom
          : "",
      clientConstProcDateFrom14:
        this.state.constProc.length > 13
          ? this.state.constProc[13].dateFrom
          : "",
      clientConstProcDateFrom15:
        this.state.constProc.length > 14
          ? this.state.constProc[14].dateFrom
          : "",

      clientConstProcDateTo1:
        this.state.constProc.length > 0 ? this.state.constProc[0].dateTo : "",
      clientConstProcDateTo2:
        this.state.constProc.length > 1 ? this.state.constProc[1].dateTo : "",
      clientConstProcDateTo3:
        this.state.constProc.length > 2 ? this.state.constProc[2].dateTo : "",
      clientConstProcDateTo4:
        this.state.constProc.length > 3 ? this.state.constProc[3].dateTo : "",
      clientConstProcDateTo5:
        this.state.constProc.length > 4 ? this.state.constProc[4].dateTo : "",
      clientConstProcDateTo6:
        this.state.constProc.length > 5 ? this.state.constProc[5].dateTo : "",
      clientConstProcDateTo7:
        this.state.constProc.length > 6 ? this.state.constProc[6].dateTo : "",
      clientConstProcDateTo8:
        this.state.constProc.length > 7 ? this.state.constProc[7].dateTo : "",
      clientConstProcDateTo9:
        this.state.constProc.length > 8 ? this.state.constProc[8].dateTo : "",
      clientConstProcDateTo10:
        this.state.constProc.length > 9 ? this.state.constProc[9].dateTo : "",
      clientConstProcDateTo11:
        this.state.constProc.length > 10 ? this.state.constProc[10].dateTo : "",
      clientConstProcDateTo12:
        this.state.constProc.length > 11 ? this.state.constProc[11].dateTo : "",
      clientConstProcDateTo13:
        this.state.constProc.length > 12 ? this.state.constProc[12].dateTo : "",
      clientConstProcDateTo14:
        this.state.constProc.length > 13 ? this.state.constProc[13].dateTo : "",
      clientConstProcDateTo15:
        this.state.constProc.length > 14 ? this.state.constProc[14].dateTo : "",

      clientConstProcValue1:
        this.state.constProc.length > 0
          ? this.state.constProc[0].value / 100
          : "",
      clientConstProcValue2:
        this.state.constProc.length > 1
          ? this.state.constProc[1].value / 100
          : "",
      clientConstProcValue3:
        this.state.constProc.length > 2
          ? this.state.constProc[2].value / 100
          : "",
      clientConstProcValue4:
        this.state.constProc.length > 3
          ? this.state.constProc[3].value / 100
          : "",
      clientConstProcValue5:
        this.state.constProc.length > 4
          ? this.state.constProc[4].value / 100
          : "",
      clientConstProcValue6:
        this.state.constProc.length > 5
          ? this.state.constProc[5].value / 100
          : "",
      clientConstProcValue7:
        this.state.constProc.length > 6
          ? this.state.constProc[6].value / 100
          : "",
      clientConstProcValue8:
        this.state.constProc.length > 7
          ? this.state.constProc[7].value / 100
          : "",
      clientConstProcValue9:
        this.state.constProc.length > 8
          ? this.state.constProc[8].value / 100
          : "",
      clientConstProcValue10:
        this.state.constProc.length > 9
          ? this.state.constProc[9].value / 100
          : "",
      clientConstProcValue11:
        this.state.constProc.length > 10
          ? this.state.constProc[10].value / 100
          : "",
      clientConstProcValue12:
        this.state.constProc.length > 11
          ? this.state.constProc[11].value / 100
          : "",
      clientConstProcValue13:
        this.state.constProc.length > 12
          ? this.state.constProc[12].value / 100
          : "",
      clientConstProcValue14:
        this.state.constProc.length > 13
          ? this.state.constProc[13].value / 100
          : "",
      clientConstProcValue15:
        this.state.constProc.length > 14
          ? this.state.constProc[14].value / 100
          : "",

      analysisAuthor: this.state.analysisAuthor,
      clientCreditAgreementPoints: this.state.agreementDetailsText,
      dateCancelCredit: this.state.creditEndDate,
      creditType: this.state.creditPaymentType,
      expertMail: this.state.userMail,
      expertPhone: this.state.userPhone,
      expertName: this.state.userName,
      clientTemplateID: this.state.userTemplateID,
      clientFolderID: this.state.userFolderID,
      companyID: this.state.companyId,
      analysisJudgmentsList: this.state.analysisJudgmentsList,
      clientBankName: this.state.clientBank,
      creditTypeText: this.state.creditTypeText,
      wiborType: this.state.wiborType,
      constRemainedDebtValue: this.state.constRemainedDebtValue,
      offerType: this.state.offerType,
      guarantee: this.state.guarantee,
      costs: this.state.costs,
    };

    url = this.state.scriptUrl;
    options = {};
    options.method = "post";
    options.payload = JSON.stringify(payload);

    fetch(url, {
      method: "post",
      body: JSON.stringify(payload),
    })
      .then((response) => response.text())
      .then((data) => {
        if (+this.state.userCompanyID === 8) {
          console.log(data);
          MySwal.fire({
            icon: "info",
            html: `
            Skopiuj link, aby pobrać analizę:
              ${data}
            `,
            confirmButtonText: "ok",
          });
        }
      })
      .catch((error) => {});

    if (+this.state.userCompanyID === 8) {
      swal({
        title: "Gratulacje",
        text: "Po wygenerowaniu analizy zobaczysz nowe okno, które umoliwi jej pobranie - dotyczy to tylko wersji DEMO. W aplikacji produkcyjnej analiza wysyłana jest na adres e-mail operatora.",
        icon: "success",
        closeOnEsc: false,
        closeOnClickOutside: false,
      }).then((value) => {
        this.clearStates();
      });
    } else {
      swal({
        title: "Gratulacje",
        text: "Gotowa analiza zostanie wysłana na adres e-mail.",
        icon: "success",
        closeOnEsc: false,
        closeOnClickOutside: false,
      }).then((value) => {
        this.clearStates();
      });
    }
  }

  handleFocus = (e) => {
    e.target.select();
  };

  handleCreditEndDateChange = (e) => {
    e.preventDefault();

    this.setState({
      creditEndDate: e.target.value,
    });
  };

  validateForm = () => {
    if (
      this.state.clientName === "" ||
      this.state.clientAgreement === "" ||
      this.state.creditValue === 0 ||
      this.state.creditDate === "" ||
      this.state.creditMargin === 0 ||
      this.state.creditLength === 0
    ) {
      return false;
    } else {
      return true;
    }
  };

  clearStates = () => {
    var currency = "";
    switch (this.state.analysisType) {
      case "chf":
        currency = "CHF";
        break;
      case "usd":
        currency = "USD";
        break;
      case "eur":
        currency = "EUR";
        break;
      case "wib":
        currency = "PLN";
        break;
      case "skd":
        currency = "PLN";
        break;
      default:
        currency = "CHF";
    }

    this.setState({
      expandButtonText: "ROZWIŃ",
      expandPointer: 0,
      expandStyle: 0,
      clientName: "",
      errorName: 0,
      clientPhone: "",
      errorPhone: 0,
      clientMail: "",
      errorMail: 0,
      comission: 0,
      expandStyleAgreement: 0,
      agreementDetailsText: "",
      chooseAgreementPointer: 0,
      clientAgreement: "",
      creditValue: 0,
      errorCreditValue: 0,
      creditCurrency: currency,
      creditDate: "",
      creditMargin: 0,
      errorCreditMargin: 0,
      creditLength: 0,
      errorCreditLength: 0,
      creditPaymentType: "równe",
      creditSpread: 3,
      errorCreditSread: 0,
      creditGracePeriod: 0,
      creditLengthChanges: [],
      actualCreditLengthChangeRowDate: "",
      actualCreditLengthChangeRowValue: 0,
      creditMarginChanges: [],
      actualCreditMarginChangeRowDate: "",
      actualCreditMarginChangeRowValue: 0,
      actualCreditSubsequentsTranchesRowDate: "",
      actualCreditSubsequentsTranchesRowValue: 0,
      actualCreditSubsequentsTranchesRowCurrency: currency,
      creditSubsequentsTranchesChanges: [],
      actualCreditEarlyRepaymentTranchesRowDate: "",
      actualCreditEarlyRepaymentRowValue: 0,
      actualCreditEarlyRepaymentRowCurrency: currency,
      creditEarlyRepaymentChanges: [],
      errorGracePeriod: 0,
      creditEndDate: "",
    });
  };

  handleDeleteJudgment = (e) => {
    e.preventDefault();
    swal({
      title: "Na pewno?",
      text: "Czy chcesz pernamentnie usunąć wyrok?",
      icon: "warning",
      buttons: true,
      dangerMode: true,
      closeOnEsc: false,
      closeOnClickOutside: false,
    }).then((willDelete) => {
      if (willDelete) {
        this.fetchDeleteJudgment(+e.target.value);
        this.setState({
          menuIndicator: "judgmentsAdd",
        });
        swal("Udało się!", {
          icon: "success",
          dangerMode: true,
          closeOnEsc: false,
          closeOnClickOutside: false,
        });
      } else {
      }
    });
  };

  handleDeleteCompany = (e) => {
    e.preventDefault();
    swal({
      title: "Na pewno?",
      text: "Czy chcesz pernamentnie usunąć firmę?",
      icon: "warning",
      buttons: true,
      dangerMode: true,
      closeOnEsc: false,
      closeOnClickOutside: false,
    }).then((willDelete) => {
      if (willDelete) {
        this.fetchDeleteCompany(e.target.value);
        this.setState({
          menuIndicator: "companiesAdd",
        });
        swal("Udało się!", {
          icon: "success",
          dangerMode: true,
          closeOnEsc: false,
          closeOnClickOutside: false,
        });
      } else {
      }
    });
  };

  handleActualJudgmentDateChange = (e) => {
    e.preventDefault();

    this.setState({
      actualJudgmentDate: e.target.value,
    });
  };

  handleActualJudgmentSignatureChange = (e) => {
    e.preventDefault();

    this.setState({
      actualJudgmentSignature: e.target.value,
    });
  };

  handleActualJudgmentCourtChange = (e) => {
    e.preventDefault();

    this.setState({
      actualJudgmentCourt: e.target.value,
    });
  };

  handleActualJudgmentBankChange = (e) => {
    e.preventDefault();

    this.setState({
      actualJudgmentBank: e.target.value,
    });
  };

  handleActualJudgmentNoteChange = (e) => {
    e.preventDefault();

    this.setState({
      actualJudgmentNote: e.target.value,
    });
  };

  handleAddJudgment = (e) => {
    e.preventDefault();

    if (this.validateJudgmentForm()) {
      this.fetchInsertJudgment();
      this.clearJudgmentStates();
      swal("Udało się!", {
        icon: "success",
        dangerMode: true,
        closeOnEsc: false,
        closeOnClickOutside: false,
      });
    } else {
      swal("Błąd!", "Uzupełnij wymagane pola formularza.", "error", {
        dangerMode: true,
        closeOnEsc: false,
        closeOnClickOutside: false,
      });
      return;
    }
  };

  validateJudgmentForm = () => {
    if (
      this.state.actualJudgmentBank === "" ||
      this.state.actualJudgmentCourt === "" ||
      this.state.actualJudgmentDate === "" ||
      this.state.actualJudgmentNote === "" ||
      this.state.actualJudgmentSignature === ""
    ) {
      return false;
    } else {
      return true;
    }
  };

  clearJudgmentStates = () => {
    this.setState({
      actualJudgmentBank: "",
      actualJudgmentCourt: "",
      actualJudgmentDate: "",
      actualJudgmentSignature: "",
      actualJudgmentNote: "",
    });
  };

  handleActualCompanyNameChange = (e) => {
    e.preventDefault();

    this.setState({
      actualCompanyName: e.target.value,
    });
  };

  handleActualCompanyTemplateIDChange = (e) => {
    e.preventDefault();

    this.setState({
      actualCompanyTemplateID: e.target.value,
    });
  };

  handleActualCompanyFolderIDChange = (e) => {
    e.preventDefault();

    this.setState({
      actualCompanyFolderID: e.target.value,
    });
  };

  handleAddCompany = (e) => {
    e.preventDefault();

    if (this.validateCompanyForm()) {
      this.fetchInsertCompany();
      this.clearCompanyStates();
      swal("Udało się!", {
        icon: "success",
        dangerMode: true,
        closeOnEsc: false,
        closeOnClickOutside: false,
      });
    } else {
      swal("Błąd!", "Uzupełnij wymagane pola formularza.", "error", {
        dangerMode: true,
        closeOnEsc: false,
        closeOnClickOutside: false,
      });
      return;
    }
  };

  validateCompanyForm = () => {
    if (
      this.state.actualCompanyName === "" ||
      this.state.actualCompanyTemplateID === "" ||
      this.state.actualCompanyFolderID === ""
    ) {
      return false;
    } else {
      return true;
    }
  };

  clearCompanyStates = () => {
    this.setState({
      actualCompanyName: "",
      actualCompanyTemplateID: "",
      actualCompanyFolderID: "",
    });
  };

  handleActualUserNameChange = (e) => {
    e.preventDefault();

    this.setState({
      actualUserName: e.target.value,
    });
  };

  handleActualUserMailChange = (e) => {
    e.preventDefault();

    this.setState({
      actualUserMail: e.target.value,
    });
  };

  handleActualUserPhoneChange = (e) => {
    e.preventDefault();

    this.setState({
      actualUserPhone: e.target.value,
    });
  };

  handleActualUserTypeChange = (e) => {
    e.preventDefault();

    this.setState({
      actualUserType: e.target.value,
    });
  };

  handleActualUserCompanyIDChange = (e) => {
    e.preventDefault();
    this.setState({
      actualUserCompanyID: +e.target.value,
    });
  };

  handleActualUserPasswordChange = (e) => {
    e.preventDefault();

    this.setState({
      actualUserPassword: e.target.value,
    });
  };

  handleAddUser = (e) => {
    e.preventDefault();

    if (this.validateUserForm()) {
      this.fetchInsertUser();
      this.clearUserStates();
      swal("Udało się!", {
        icon: "success",
        dangerMode: true,
        closeOnEsc: false,
        closeOnClickOutside: false,
      });
    } else {
      swal("Błąd!", "Uzupełnij wymagane pola formularza.", "error", {
        dangerMode: true,
        closeOnEsc: false,
        closeOnClickOutside: false,
      });
      return;
    }
  };

  handleDeleteUser = (e) => {
    e.preventDefault();
    swal({
      title: "Na pewno?",
      text: "Czy chcesz pernamentnie usunąć uzytkownika?",
      icon: "warning",
      buttons: true,
      dangerMode: true,
      closeOnEsc: false,
      closeOnClickOutside: false,
    }).then((willDelete) => {
      if (willDelete) {
        this.fetchDeleteUser(e.target.value);
        this.setState({
          menuIndicator: "usersAdd",
        });
        swal("Udało się!", {
          icon: "success",
          dangerMode: true,
          closeOnEsc: false,
          closeOnClickOutside: false,
        });
      } else {
      }
    });
  };

  validateUserForm = () => {
    if (
      this.state.actualUserName === "" ||
      this.state.actualUserMail === "" ||
      this.state.actualUserPhone === "" ||
      this.state.actualUserType === "" ||
      this.state.actualUserCompanyID === "" ||
      this.state.actualUserPassword === ""
    ) {
      return false;
    } else {
      return true;
    }
  };

  clearUserStates = () => {
    this.setState({
      actualUserName: "",
      actualUserMail: "",
      actualUserPhone: "",
      actualUserType: "",
      actualUserCompanyID: "",
      actualUserPassword: "",
    });
  };

  getTemplateId = (type) => {
    var company = this.state.companiesList.filter(
      (e) => e.id === +this.state.userCompanyID
    )[0];
    switch (type) {
      case "chf":
        return company.templateChfId;
      case "eur":
        return company.templateEurId;
      case "dol":
        return company.templateDolId;
      case "wib":
        return company.templateWibId;
      case "skd":
        return company.templateSkdId;
      default:
        return company.templateChfId;
    }
  };

  changeAnalysisType = (e) => {
    switch (e.target.value) {
      case "chf": {
        this.fetchAgreementText(this.state.clientAgreement);
        this.setState({
          analysisType: e.target.value,
          scriptUrl: this.state.scripts.chfUrl,
          userTemplateID:
            this.getTemplateId(e.target.value).split("/").length > 0
              ? this.getTemplateId(e.target.value).split("/")[0]
              : this.getTemplateId(e.target.value),
          creditCurrency: "CHF",
          actualCreditEarlyRepaymentRowCurrency: "CHF",
          actualCreditSubsequentsTranchesRowCurrency: "CHF",
        });
        break;
      }
      case "eur": {
        this.fetchAgreementText(this.state.clientAgreement);
        this.setState({
          analysisType: e.target.value,
          scriptUrl: this.state.scripts.eurUrl,
          userTemplateID:
            this.getTemplateId(e.target.value).split("/").length > 0
              ? this.getTemplateId(e.target.value).split("/")[0]
              : this.getTemplateId(e.target.value),
          creditCurrency: "EUR",
          actualCreditEarlyRepaymentRowCurrency: "EUR",
          actualCreditSubsequentsTranchesRowCurrency: "EUR",
        });
        break;
      }
      case "dol": {
        this.fetchAgreementText(this.state.clientAgreement);
        this.setState({
          analysisType: e.target.value,
          scriptUrl: this.state.scripts.dolUrl,
          userTemplateID:
            this.getTemplateId(e.target.value).split("/").length > 0
              ? this.getTemplateId(e.target.value).split("/")[0]
              : this.getTemplateId(e.target.value),
          creditCurrency: "USD",
          actualCreditEarlyRepaymentRowCurrency: "USD",
          actualCreditSubsequentsTranchesRowCurrency: "USD",
        });
        break;
      }
      case "wib": {
        this.setState({
          analysisType: e.target.value,
          scriptUrl: this.state.scripts.dolUrl,
          userTemplateID:
            this.getTemplateId(e.target.value).split("/").length > 0
              ? this.getTemplateId(e.target.value).split("/")[0]
              : this.getTemplateId(e.target.value),
          creditCurrency: "PLN",
          actualCreditEarlyRepaymentRowCurrency: "PLN",
          actualCreditSubsequentsTranchesRowCurrency: "PLN",
        });
        break;
      }
      case "skd": {
        this.setState({
          analysisType: e.target.value,
          scriptUrl: this.state.scripts.dolUrl,
          userTemplateID:
            this.getTemplateId(e.target.value).split("/").length > 0
              ? this.getTemplateId(e.target.value).split("/")[0]
              : this.getTemplateId(e.target.value),
          creditCurrency: "PLN",
          actualCreditEarlyRepaymentRowCurrency: "PLN",
          actualCreditSubsequentsTranchesRowCurrency: "PLN",
        });
        break;
      }
      default:
        break;
    }
  };

  changeAnalysisType2 = (type) => {
    switch (type) {
      case "chf": {
        this.fetchAgreementText(this.state.clientAgreement);
        this.setState({
          analysisType: type,
          scriptUrl: this.state.scripts.chfUrl,
          userTemplateID:
            this.getTemplateId(type).split("/").length > 0
              ? this.getTemplateId(type).split("/")[0]
              : this.getTemplateId(type),
          creditCurrency: "CHF",
          actualCreditEarlyRepaymentRowCurrency: "CHF",
          actualCreditSubsequentsTranchesRowCurrency: "CHF",
        });
        break;
      }
      case "eur": {
        this.fetchAgreementText(this.state.clientAgreement);
        this.setState({
          analysisType: type,
          scriptUrl: this.state.scripts.eurUrl,
          userTemplateID:
            this.getTemplateId(type).split("/").length > 0
              ? this.getTemplateId(type).split("/")[0]
              : this.getTemplateId(type),
          creditCurrency: "EUR",
          actualCreditEarlyRepaymentRowCurrency: "EUR",
          actualCreditSubsequentsTranchesRowCurrency: "EUR",
        });
        break;
      }
      case "dol": {
        this.fetchAgreementText(this.state.clientAgreement);
        this.setState({
          analysisType: type,
          scriptUrl: this.state.scripts.dolUrl,
          userTemplateID:
            this.getTemplateId(type).split("/").length > 0
              ? this.getTemplateId(type).split("/")[0]
              : this.getTemplateId(type),
          creditCurrency: "USD",
          actualCreditEarlyRepaymentRowCurrency: "USD",
          actualCreditSubsequentsTranchesRowCurrency: "USD",
        });
        break;
      }
      case "wib": {
        this.setState({
          analysisType: type,
          scriptUrl: this.state.scripts.dolUrl,
          userTemplateID:
            this.getTemplateId(type).split("/").length > 0
              ? this.getTemplateId(type).split("/")[0]
              : this.getTemplateId(type),
          creditCurrency: "PLN",
          actualCreditEarlyRepaymentRowCurrency: "PLN",
          actualCreditSubsequentsTranchesRowCurrency: "PLN",
        });
        break;
      }
      case "skd": {
        this.setState({
          analysisType: type,
          scriptUrl: this.state.scripts.dolUrl,
          userTemplateID:
            this.getTemplateId(type).split("/").length > 0
              ? this.getTemplateId(type).split("/")[0]
              : this.getTemplateId(type),
          creditCurrency: "PLN",
          actualCreditEarlyRepaymentRowCurrency: "PLN",
          actualCreditSubsequentsTranchesRowCurrency: "PLN",
        });
        break;
      }
      default:
        break;
    }
  };

  render() {
    return (
      <>
        {this.state.loggedIn === 0 ? (
          <div className="blackBox"></div>
        ) : (
          <>
            <Header
              changeAnalysisType={this.changeAnalysisType}
              analysisType={this.state.analysisType}
              calcTypes={this.state.calcTypes}
            />
            <div className="mainComponent">
              <div className="col1">
                <div className="menuEl">
                  <div className="el">
                    <button
                      className="buttonMenu"
                      onClick={this.handleMenuIndicatorChangeCalc}
                    >
                      Kalkulator umowy kredytowej
                    </button>
                  </div>

                  {(this.state.userType === "admin" ||
                    this.state.userType === "user") &&
                  +this.state.userCompanyID !== 9 ? (
                    <div className="el">
                      <button
                        className="buttonMenu"
                        onClick={this.handleMenuIndicatorChangeJudgmentsAdd}
                      >
                        Dodaj wyrok
                      </button>
                    </div>
                  ) : (
                    ""
                  )}

                  {(this.state.userType === "admin" ||
                    this.state.userType === "user") &&
                  +this.state.userCompanyID !== 9 ? (
                    <div className="el">
                      <button
                        className="buttonMenu"
                        onClick={this.handleMenuIndicatorChangeJudgmentsList}
                      >
                        Lista wyroków
                      </button>
                    </div>
                  ) : (
                    ""
                  )}

                  {this.state.userType === "a" ? (
                    <div className="el">
                      <button
                        className="buttonMenu"
                        onClick={this.handleMenuIndicatorChangeCompaniesAdd}
                      >
                        Dodaj firmę
                      </button>
                    </div>
                  ) : (
                    ""
                  )}

                  {this.state.userType === "a" ? (
                    <div className="el">
                      <button
                        className="buttonMenu"
                        onClick={this.handleMenuIndicatorChangeCompaniesList}
                      >
                        Lista firm
                      </button>
                    </div>
                  ) : (
                    ""
                  )}

                  {this.state.userType === "a" ? (
                    <div className="el">
                      <button
                        className="buttonMenu"
                        onClick={this.handleMenuIndicatorChangeUsersAdd}
                      >
                        Dodaj uzytkownika
                      </button>
                    </div>
                  ) : (
                    ""
                  )}

                  {this.state.userType === "a" ? (
                    <div className="el">
                      <button
                        className="buttonMenu"
                        onClick={this.handleMenuIndicatorChangeUsersList}
                      >
                        Lista uzytkowników
                      </button>
                    </div>
                  ) : (
                    ""
                  )}
                </div>

                <div className="el2">
                  <font color="#ff933b">Imię i nazwisko:</font>
                  <br />
                  {this.state.userName}
                  <br />
                </div>
                <div className="el">
                  <font color="#ff933b">Adres e-mail:</font>
                  <br />
                  {this.state.userMail}
                  <br />
                </div>
                <div className="el">
                  <font color="#ff933b">Numer telefonu:</font>
                  <br />
                  {this.state.userPhone}
                  <br />
                </div>
                <div className="el">
                  <font color="#ff933b">Firma:</font>
                  <br />
                  {this.state.userCompany}
                  <br />
                </div>
              </div>
              <div className="col2">
                {this.state.menuIndicator === "calc" ? (
                  <CalcInputs
                    specialTemplates={this.state.specialTemplates}
                    specialTemplate={this.state.specialTemplate}
                    handleSpecialTemplateChange={
                      this.handleSpecialTemplateChange
                    }
                    guarantee={this.state.guarantee}
                    costs={this.state.costs}
                    handleGuaranteeChange={this.handleGuaranteeChange}
                    handleCostsChange={this.handleCostsChange}
                    offerType={this.state.offerType}
                    handleOfferTypeChange={this.handleOfferTypeChange}
                    wiborType={this.state.wiborType}
                    creditTypeText={this.state.creditTypeText}
                    userCompanyID={this.state.userCompanyID}
                    analysisType={this.state.analysisType}
                    clientName={this.state.clientName}
                    handleClientNameChange={this.handleClientNameChange}
                    errorName={this.state.errorName}
                    expandAdditionalData={this.expandAdditionalData}
                    expandStyle={this.state.expandStyle}
                    expandButtonText={this.state.expandButtonText}
                    clientPhone={this.state.clientPhone}
                    handleClientPhoneChange={this.handleClientPhoneChange}
                    errorPhone={this.state.errorPhone}
                    clientMail={this.state.clientMail}
                    handleClientMailChange={this.handleClientMailChange}
                    errorMail={this.state.errorMail}
                    optionsAgreements={this.state.agreements}
                    handleShowAgreementPointsDetails={
                      this.handleShowAgreementPointsDetails
                    }
                    expandStyleAgreement={this.state.expandStyleAgreement}
                    agreementDetailsText={this.state.agreementDetailsText}
                    handleAgreementDetailsTextChange={
                      this.handleAgreementDetailsTextChange
                    }
                    handleAgreementChange={this.handleAgreementChange}
                    clientAgreement={this.state.clientAgreement}
                    chooseAgreementPointer={this.state.chooseAgreementPointer}
                    handleCreditValueChange={this.handleCreditValueChange}
                    creditValue={+this.state.creditValue}
                    errorCreditValue={this.state.errorCreditValue}
                    creditCurrency={this.state.creditCurrency}
                    handleCreditCurrencyChange={this.handleCreditCurrencyChange}
                    creditDate={this.state.creditDate}
                    handleCreditDateChange={this.handleCreditDateChange}
                    creditMargin={this.state.creditMargin}
                    errorCreditMargin={this.state.errorCreditMargin}
                    handleCreditMarginChange={this.handleCreditMarginChange}
                    creditLength={this.state.creditLength}
                    errorCreditLength={this.state.errorCreditLength}
                    handleCreditLengthChange={this.handleCreditLengthChange}
                    handleCreditTypeTextChange={this.handleCreditTypeTextChange}
                    handleWiborTypeChange={this.handleWiborTypeChange}
                    creditPaymentType={this.state.creditPaymentType}
                    handleCreditPaymentTypeChange={
                      this.handleCreditPaymentTypeChange
                    }
                    creditSpread={this.state.creditSpread}
                    errorCreditSpread={this.state.errorCreditSpread}
                    handleCreditSpreadChange={this.handleCreditSpreadChange}
                    creditGracePeriod={this.state.creditGracePeriod}
                    handleCreditGracePeriodChange={
                      this.handleCreditGracePeriodChange
                    }
                    actualCreditLengthChangeRowDate={
                      this.state.actualCreditLengthChangeRowDate
                    }
                    actualCreditLengthChangeRowValue={
                      this.state.actualCreditLengthChangeRowValue
                    }
                    handleActualCreditLengthChangeRowDateChange={
                      this.handleActualCreditLengthChangeRowDateChange
                    }
                    handleActualCreditLengthChangeRowValueChange={
                      this.handleActualCreditLengthChangeRowValueChange
                    }
                    creditLengthChanges={this.state.creditLengthChanges}
                    handleAddCreditLengthChange={
                      this.handleAddCreditLengthChange
                    }
                    handleDeleteCreditLengthChange={
                      this.handleDeleteCreditLengthChange
                    }
                    actualCreditMarginChangeRowDate={
                      this.state.actualCreditMarginChangeRowDate
                    }
                    actualCreditMarginChangeRowValue={
                      this.state.actualCreditMarginChangeRowValue
                    }
                    handleActualCreditMarginChangeRowDateChange={
                      this.handleActualCreditMarginChangeRowDateChange
                    }
                    handleActualCreditMarginChangeRowValueChange={
                      this.handleActualCreditMarginChangeRowValueChange
                    }
                    creditMarginChanges={this.state.creditMarginChanges}
                    handleAddCreditMarginChange={
                      this.handleAddCreditMarginChange
                    }
                    handleDeleteCreditMarginChange={
                      this.handleDeleteCreditMarginChange
                    }
                    actualCreditSubsequentsTranchesRowDate={
                      this.state.actualCreditSubsequentsTranchesRowDate
                    }
                    actualCreditSubsequentsTranchesRowValue={
                      this.state.actualCreditSubsequentsTranchesRowValue
                    }
                    actualCreditSubsequentsTranchesRowCurrency={
                      this.state.actualCreditSubsequentsTranchesRowCurrency
                    }
                    handleActualCreditSubsequentsTranchesRowDateChange={
                      this.handleActualCreditSubsequentsTranchesRowDateChange
                    }
                    handleActualCreditSubsequentsTranchesRowValueChange={
                      this.handleActualCreditSubsequentsTranchesRowValueChange
                    }
                    handleActualCreditSubsequentsTranchesRowCurrencyChange={
                      this
                        .handleActualCreditSubsequentsTranchesRowCurrencyChange
                    }
                    creditSubsequentsTranchesChanges={
                      this.state.creditSubsequentsTranchesChanges
                    }
                    handleAddCreditSubsequentsTranchesChange={
                      this.handleAddCreditSubsequentsTranchesChange
                    }
                    handleDeleteCreditSubsequentsTranchesChange={
                      this.handleDeleteCreditSubsequentsTranchesChange
                    }
                    actualCreditEarlyRepaymentRowDate={
                      this.state.actualCreditEarlyRepaymentRowDate
                    }
                    actualCreditEarlyRepaymentRowValue={
                      this.state.actualCreditEarlyRepaymentRowValue
                    }
                    actualCreditEarlyRepaymentRowCurrency={
                      this.state.actualCreditEarlyRepaymentRowCurrency
                    }
                    handleActualCreditEarlyRepaymentRowDateChange={
                      this.handleActualCreditEarlyRepaymentRowDateChange
                    }
                    handleActualCreditEarlyRepaymentRowValueChange={
                      this.handleActualCreditEarlyRepaymentRowValueChange
                    }
                    handleActualCreditEarlyRepaymentRowCurrencyChange={
                      this.handleActualCreditEarlyRepaymentRowCurrencyChange
                    }
                    creditEarlyRepaymentChanges={
                      this.state.creditEarlyRepaymentChanges
                    }
                    handleAddCreditEarlyRepaymentChange={
                      this.handleAddCreditEarlyRepaymentChange
                    }
                    handleDeleteCreditEarlyRepaymentChange={
                      this.handleDeleteCreditEarlyRepaymentChange
                    }
                    actualConstProcDateFrom={this.state.actualConstProcDateFrom}
                    actualConstProcDateTo={this.state.actualConstProcDateTo}
                    actualConstProcValue={this.state.actualConstProcValue}
                    handleActualConstProcDateFromChange={
                      this.handleActualConstProcDateFromChange
                    }
                    handleActualConstProcDateToChange={
                      this.handleActualConstProcDateToChange
                    }
                    handleActualConstProcValueChange={
                      this.handleActualConstProcValueChange
                    }
                    constProc={this.state.constProc}
                    handleAddConstProc={this.handleConstProcChange}
                    handleDeleteConstProc={this.handleDeleteConstProc}
                    doAnalysis={this.doAnalysis}
                    handleFocus={this.handleFocus}
                    errorGracePeriod={this.state.errorGracePeriod}
                    handleCreditEndDateChange={this.handleCreditEndDateChange}
                    creditEndDate={this.state.creditEndDate}
                    companyId={this.state.userCompanyID}
                    additionalFunctions={this.state.additionalFunctions}
                    constRemainedDebtValue={this.state.constRemainedDebtValue}
                    handleConstRemainedDebtValue={
                      this.handleConstRemainedDebtValue
                    }
                    errorConstRemainedDebtValue={
                      this.state.errorConstRemainedDebtValue
                    }
                    comission={this.state.comission}
                    handleComission={this.handleComission}
                    errorComission={this.state.errorComission}
                  />
                ) : this.state.menuIndicator === "judgmentsList" ? (
                  <JudgmentsList
                    judgmentsList={this.state.judgmentsList}
                    handleDeleteJudgment={this.handleDeleteJudgment}
                  />
                ) : this.state.menuIndicator === "judgmentsAdd" ? (
                  <JudgmentsAdd
                    banksList={this.state.banksList}
                    actualJudgmentDate={this.state.actualJudgmentDate}
                    actualJudgmentSignature={this.state.actualJudgmentSignature}
                    actualJudgmentCourt={this.state.actualJudgmentCourt}
                    actualJudgmentBank={this.state.actualJudgmentBank}
                    actualJudgmentNote={this.state.actualJudgmentNote}
                    handleActualJudgmentDateChange={
                      this.handleActualJudgmentDateChange
                    }
                    handleActualJudgmentSignatureChange={
                      this.handleActualJudgmentSignatureChange
                    }
                    handleActualJudgmentCourtChange={
                      this.handleActualJudgmentCourtChange
                    }
                    handleActualJudgmentBankChange={
                      this.handleActualJudgmentBankChange
                    }
                    handleActualJudgmentNoteChange={
                      this.handleActualJudgmentNoteChange
                    }
                    handleAddJudgment={this.handleAddJudgment}
                  />
                ) : this.state.menuIndicator === "companiesList" ? (
                  <CompaniesList
                    companiesList={this.state.companiesList}
                    handleDeleteCompany={this.handleDeleteCompany}
                    encrypt={this.encrypt}
                    decrypt={this.decrypt}
                  />
                ) : this.state.menuIndicator === "companiesAdd" ? (
                  <CompaniesAdd
                    actualCompanyName={this.state.actualCompanyName}
                    actualCompanyTemplateID={this.state.actualCompanyTemplateID}
                    actualCompanyFolderID={this.state.actualCompanyFolderID}
                    handleActualCompanyNameChange={
                      this.handleActualCompanyNameChange
                    }
                    handleActualCompanyTemplateIDChange={
                      this.handleActualCompanyTemplateIDChange
                    }
                    handleActualCompanyFolderIDChange={
                      this.handleActualCompanyFolderIDChange
                    }
                    handleAddCompany={this.handleAddCompany}
                  />
                ) : this.state.menuIndicator === "usersList" ? (
                  <UsersList
                    usersList={this.state.usersList}
                    handleDeleteUser={this.handleDeleteUser}
                    encrypt={this.encrypt}
                    decrypt={this.decrypt}
                  />
                ) : this.state.menuIndicator === "usersAdd" ? (
                  <UsersAdd
                    companiesList={this.state.companiesList}
                    actualUserName={this.state.actualUserName}
                    actualUserMail={this.state.actualUserMail}
                    actualUserPhone={this.state.actualUserPhone}
                    actualUserType={this.state.actualUserType}
                    actualUserCompanyID={this.state.actualUserCompanyID}
                    actualUserPassword={this.state.actualUserPassword}
                    handleActualUserNameChange={this.handleActualUserNameChange}
                    handleActualUserMailChange={this.handleActualUserMailChange}
                    handleActualUserPhoneChange={
                      this.handleActualUserPhoneChange
                    }
                    handleActualUserTypeChange={this.handleActualUserTypeChange}
                    handleActualUserCompanyIDChange={
                      this.handleActualUserCompanyIDChange
                    }
                    handleActualUserPasswordChange={
                      this.handleActualUserPasswordChange
                    }
                    handleAddUser={this.handleAddUser}
                    encrypt={this.encrypt}
                    decrypt={this.decrypt}
                  />
                ) : (
                  ""
                )}
              </div>
            </div>
            <Footer />
          </>
        )}
      </>
    );
  }
}

export default App;
